<svg width="0" height="0" class="hidden" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <symbol viewBox="0 0 48 48" id="arrow-down" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M23.9835 8.00633C23.5606 8.01429 23.158 8.18911 22.8635 8.49268C22.569 8.79626 22.4064 9.20396 22.4113 9.62689V34.5702L10.753 22.8877C10.6035 22.7344 10.4248 22.6126 10.2275 22.5295C10.0301 22.4464 9.81817 22.4037 9.60406 22.4039C9.28507 22.4036 8.97324 22.4985 8.7085 22.6764C8.44376 22.8544 8.23816 23.1073 8.11801 23.4028C7.99786 23.6983 7.96864 24.0229 8.03409 24.3351C8.09954 24.6473 8.25668 24.9329 8.48539 25.1552L22.8769 39.5468C23.0708 39.7421 23.3118 39.8843 23.5765 39.9595C23.8413 40.0347 24.121 40.0404 24.3886 39.9761C24.4397 39.9645 24.4901 39.9503 24.5398 39.9338C24.5912 39.9162 24.6416 39.896 24.691 39.8733C24.7385 39.8514 24.7849 39.8272 24.8301 39.8007L24.8422 39.7947C24.8836 39.7703 24.924 39.7441 24.9631 39.7161C24.9985 39.6893 25.0328 39.6611 25.0659 39.6314L25.0901 39.6072C25.1108 39.5876 25.1309 39.5675 25.1505 39.5468L25.205 39.4923L39.5481 25.1492C39.713 25.0049 39.8465 24.8284 39.9405 24.6306C40.0344 24.4327 40.0868 24.2176 40.0944 23.9987C40.102 23.7798 40.0646 23.5616 39.9846 23.3577C39.9045 23.1538 39.7835 22.9685 39.6291 22.8132C39.4746 22.6579 39.2899 22.5359 39.0864 22.4548C38.8829 22.3736 38.665 22.3351 38.446 22.3415C38.2271 22.3479 38.0118 22.3991 37.8134 22.492C37.615 22.5849 37.4378 22.7175 37.2926 22.8816L25.6222 34.5521V9.62085C25.6247 9.40632 25.584 9.19349 25.5027 8.99497C25.4214 8.79644 25.301 8.61627 25.1487 8.46513C24.9965 8.314 24.8154 8.19498 24.6163 8.11513C24.4172 8.03528 24.204 7.99623 23.9895 8.00029L23.9835 8.00633Z" />
  </symbol>
  <symbol viewBox="0 0 6.35 7.938" id="arrow-up" xmlns="http://www.w3.org/2000/svg">
    <path style="
        line-height: normal;
        font-variant-ligatures: normal;
        font-variant-position: normal;
        font-variant-caps: normal;
        font-variant-numeric: normal;
        font-variant-alternates: normal;
        font-feature-settings: normal;
        text-indent: 0;
        text-align: start;
        text-decoration-line: none;
        text-decoration-style: solid;
        text-decoration-color: #000;
        text-transform: none;
        text-orientation: mixed;
        white-space: normal;
        shape-padding: 0;
        isolation: auto;
        mix-blend-mode: normal;
        solid-color: #000;
        solid-opacity: 1;
      "
      d="M3.17.526a.265.265 0 00-.205.104L.605 2.987a.265.265 0 00.376.375L2.91 1.43v4.125a.265.265 0 10.53 0V1.433L5.37 3.362a.265.265 0 10.373-.375L3.383.628A.265.265 0 003.17.526z"
      font-weight="400" font-family="sans-serif" overflow="visible" />
    <text y="21.35" font-size="5" font-weight="bold"
      font-family="'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif">
      Created by Handicon
    </text>
    <text y="26.35" font-size="5" font-weight="bold"
      font-family="'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif">
      from the Noun Project
    </text>
  </symbol>
  <symbol viewBox="0 0 24 24" id="board" iconlabel="Kanban">
    <g fill="currentColor">
      <path
        d="M4 18h16.008C20 18 20 6 20 6H3.992C4 6 4 18 4 18zM2 5.994C2 4.893 2.898 4 3.99 4h16.02C21.108 4 22 4.895 22 5.994v12.012A1.997 1.997 0 0120.01 20H3.99A1.994 1.994 0 012 18.006V5.994z" />
      <path d="M8 6v12h2V6zm6 0v12h2V6z" />
    </g>
  </symbol>
  <symbol viewBox="0 0 16 16" id="bug" iconlabel="Problema" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(1 1)" fill="none" fill-rule="evenodd">
      <rect fill="#E5493A" width="14" height="14" rx="2" />
      <path d="M10 7a3 3 0 11-6 0 3 3 0 016 0" fill="#FFF" />
    </g>
  </symbol>
  <symbol viewBox="0 0 24 24" id="chevron-down">
    <path
      d="M8.292 10.293a1.009 1.009 0 000 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 000-1.419.987.987 0 00-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 00-1.406 0z"
      fill="currentColor" fill-rule="evenodd" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="chevron-left">
    <path
      d="M13.706 9.698a.988.988 0 000-1.407 1.01 1.01 0 00-1.419 0l-2.965 2.94a1.09 1.09 0 000 1.548l2.955 2.93a1.01 1.01 0 001.42 0 .988.988 0 000-1.407l-2.318-2.297 2.327-2.307z"
      fill="currentColor" fill-rule="evenodd" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="chevron-right">
    <path
      d="M10.294 9.698a.988.988 0 010-1.407 1.01 1.01 0 011.419 0l2.965 2.94a1.09 1.09 0 010 1.548l-2.955 2.93a1.01 1.01 0 01-1.42 0 .988.988 0 010-1.407l2.318-2.297-2.327-2.307z"
      fill="currentColor" fill-rule="evenodd" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="cog" iconlabel="Impostazioni">
    <path
      d="M11.701 16.7a5.002 5.002 0 110-10.003 5.002 5.002 0 010 10.004m8.368-3.117a1.995 1.995 0 01-1.346-1.885c0-.876.563-1.613 1.345-1.885a.48.48 0 00.315-.574 8.947 8.947 0 00-.836-1.993.477.477 0 00-.598-.195 2.04 2.04 0 01-1.29.08 1.988 1.988 0 01-1.404-1.395 2.04 2.04 0 01.076-1.297.478.478 0 00-.196-.597 8.98 8.98 0 00-1.975-.826.479.479 0 00-.574.314 1.995 1.995 0 01-1.885 1.346 1.994 1.994 0 01-1.884-1.345.482.482 0 00-.575-.315c-.708.2-1.379.485-2.004.842a.47.47 0 00-.198.582A2.002 2.002 0 014.445 7.06a.478.478 0 00-.595.196 8.946 8.946 0 00-.833 1.994.48.48 0 00.308.572 1.995 1.995 0 011.323 1.877c0 .867-.552 1.599-1.324 1.877a.479.479 0 00-.308.57 8.99 8.99 0 00.723 1.79.477.477 0 00.624.194c.595-.273 1.343-.264 2.104.238.117.077.225.185.302.3.527.8.512 1.58.198 2.188a.473.473 0 00.168.628 8.946 8.946 0 002.11.897.474.474 0 00.57-.313 1.995 1.995 0 011.886-1.353c.878 0 1.618.567 1.887 1.353a.475.475 0 00.57.313 8.964 8.964 0 002.084-.883.473.473 0 00.167-.631c-.318-.608-.337-1.393.191-2.195.077-.116.185-.225.302-.302.772-.511 1.527-.513 2.125-.23a.477.477 0 00.628-.19 8.925 8.925 0 00.728-1.793.478.478 0 00-.314-.573"
      fill="currentColor" fill-rule="evenodd" />
  </symbol>
  <symbol xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="40"
    height="40" viewBox="0 0 256 256" xml:space="preserve" id="projects" iconlabel="Progetti">
    <g transform="translate(128 128) scale(0.72 0.72)">
      <g style="
          stroke: none;
          stroke-width: 0;
          stroke-dasharray: none;
          stroke-linecap: butt;
          stroke-linejoin: miter;
          stroke-miterlimit: 10;
          fill: none;
          fill-rule: nonzero;
          opacity: 1;
        " transform="translate(-175.05 -175.05) scale(3.89 3.89)">
        <circle cx="45" cy="45" r="45" style="
            stroke: none;
            stroke-width: 1;
            stroke-dasharray: none;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke-miterlimit: 10;
            fill: rgb(32, 196, 203);
            fill-rule: nonzero;
            opacity: 1;
          " transform="  matrix(1 0 0 1 0 0) " />
        <path
          d="M 54.654 19.773 H 23.802 c -1.011 0 -1.83 0.819 -1.83 1.83 V 74.67 c 0 1.011 0.819 1.83 1.83 1.83 h 38.123 c 1.011 0 1.83 -0.819 1.83 -1.83 V 28.535 L 54.654 19.773 z M 27.402 28.007 h 15.461 v 4.221 H 27.402 V 28.007 z M 58.325 68.655 H 27.402 v -4.221 h 30.923 V 68.655 z M 58.325 61.393 H 27.402 v -4.221 h 30.923 V 61.393 z M 58.325 54.13 H 27.402 v -4.221 h 30.923 V 54.13 z M 58.325 46.868 H 27.402 v -4.221 h 30.923 V 46.868 z M 58.325 39.548 H 27.402 v -4.221 h 30.923 V 39.548 z M 54.654 30.365 c -1.011 0 -1.83 -0.819 -1.83 -1.83 v -6.933 l 9.101 8.763 H 54.654 z"
          style="
            stroke: none;
            stroke-width: 1;
            stroke-dasharray: none;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke-miterlimit: 10;
            fill: rgb(27, 167, 173);
            fill-rule: nonzero;
            opacity: 1;
          " transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
        <path
          d="M 57.927 16.5 H 27.075 c -1.011 0 -1.83 0.819 -1.83 1.83 v 53.067 c 0 1.011 0.819 1.83 1.83 1.83 h 38.123 c 1.011 0 1.83 -0.819 1.83 -1.83 V 25.263 L 57.927 16.5 z M 30.675 24.735 h 15.461 v 4.221 H 30.675 V 24.735 z M 61.598 65.382 H 30.675 v -4.221 h 30.923 V 65.382 z M 61.598 58.12 H 30.675 v -4.221 h 30.923 V 58.12 z M 61.598 50.858 H 30.675 v -4.221 h 30.923 V 50.858 z M 61.598 43.595 H 30.675 v -4.221 h 30.923 V 43.595 z M 61.598 36.276 H 30.675 v -4.221 h 30.923 V 36.276 z M 57.927 27.093 c -1.011 0 -1.83 -0.819 -1.83 -1.83 V 18.33 l 9.101 8.763 H 57.927 z"
          style="
            stroke: none;
            stroke-width: 1;
            stroke-dasharray: none;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke-miterlimit: 10;
            fill: rgb(255, 255, 255);
            fill-rule: nonzero;
            opacity: 1;
          " transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
      </g>
    </g>
  </symbol>
  <symbol viewBox="0 0 24 24" id="component" iconlabel="Componente">
    <g fill="currentColor" fill-rule="evenodd">
      <path
        d="M5 17.991c0 .007 14.005.009 14.005.009-.006 0-.005-7.991-.005-7.991C19 10.002 4.995 10 4.995 10 5.001 10 5 17.991 5 17.991zM3 10.01C3 8.899 3.893 8 4.995 8h14.01C20.107 8 21 8.902 21 10.009v7.982c0 1.11-.893 2.009-1.995 2.009H4.995A2.004 2.004 0 013 17.991V10.01z" />
      <path
        d="M7 8.335c0-.002 2.002-.002 2.002-.002C9 8.333 9 6.665 9 6.665c0 .002-2.002.002-2.002.002C7 6.667 7 8.335 7 8.335zm-2-1.67C5 5.745 5.898 5 6.998 5h2.004C10.106 5 11 5.749 11 6.665v1.67C11 9.255 10.102 10 9.002 10H6.998C5.894 10 5 9.251 5 8.335v-1.67zm10 1.67c0-.002 2.002-.002 2.002-.002C17 8.333 17 6.665 17 6.665c0 .002-2.002.002-2.002.002.002 0 .002 1.668.002 1.668zm-2-1.67C13 5.745 13.898 5 14.998 5h2.004C18.106 5 19 5.749 19 6.665v1.67c0 .92-.898 1.665-1.998 1.665h-2.004C13.894 10 13 9.251 13 8.335v-1.67z" />
    </g>
  </symbol>
  <symbol viewBox="0 0 24 24" id="feedback" iconlabel="Feedback">
    <path
      d="M10.881 5.48l-8.426 6.829c-.396.32-.582.956-.413 1.417l.099.272c.168.462.726.829 1.227.82l1.131-.02 6.062-.102 3.652-.063c.51-.01.788-.385.616-.861l-2.923-8.03c-.105-.288-.324-.441-.567-.441a.731.731 0 00-.458.179zM4.98 15.953l1.754 4.818a1 1 0 101.879-.684l-1.539-4.228-2.094.094zm13.711-9.111l-2.819 1.026a1 1 0 10.684 1.879l2.82-1.026a1 1 0 10-.685-1.88zm-1.792 3.845a1.006 1.006 0 00-.644.766 1.002 1.002 0 00.811 1.159l2.955.52a1 1 0 001.122-1.301l-.017-.047a.997.997 0 00-.758-.621l-2.955-.521a.974.974 0 00-.514.045zm-.548-7.639l-1.929 2.298a1 1 0 001.532 1.286l1.928-2.298a1.001 1.001 0 00-.765-1.643.993.993 0 00-.766.357z"
      fill="currentColor" fill-rule="evenodd" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="filters" iconlabel="Filtri">
    <g fill="currentColor" fill-rule="evenodd">
      <path
        d="M5 12.991c0 .007 14.005.009 14.005.009C18.999 13 19 5.009 19 5.009 19 5.002 4.995 5 4.995 5 5.001 5 5 12.991 5 12.991zM3 5.01C3 3.899 3.893 3 4.995 3h14.01C20.107 3 21 3.902 21 5.009v7.982c0 1.11-.893 2.009-1.995 2.009H4.995A2.004 2.004 0 013 12.991V5.01zM19 19c-.005 1.105-.9 2-2.006 2H7.006A2.009 2.009 0 015 19h14zm1-3a2.002 2.002 0 01-1.994 2H5.994A2.003 2.003 0 014 16h16z"
        fill-rule="nonzero" />
      <path
        d="M10.674 11.331c.36.36.941.36 1.3 0l2.758-2.763a.92.92 0 00-1.301-1.298l-2.108 2.11-.755-.754a.92.92 0 00-1.3 1.3l1.406 1.405z" />
    </g>
  </symbol>
  <symbol viewBox="0 0 24 24" id="help">
    <g fill-rule="evenodd">
      <circle fill="currentColor" cx="12" cy="12" r="10" />
      <circle fill="inherit" cx="12" cy="18" r="1" />
      <path
        d="M15.89 9.05a3.975 3.975 0 00-2.957-2.942C10.321 5.514 8.017 7.446 8 9.95l.005.147a.992.992 0 00.982.904c.552 0 1-.447 1.002-.998a2.004 2.004 0 014.007-.002c0 1.102-.898 2-2.003 2H12a1 1 0 00-1 .987v2.014a1.001 1.001 0 002.004 0v-.782c0-.217.145-.399.35-.472A3.99 3.99 0 0015.89 9.05"
        fill="inherit" />
    </g>
  </symbol>
  <symbol viewBox="0 0 24 24" id="github">
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M12.026,2c-5.509,0-9.974,4.465-9.974,9.974c0,4.406,2.857,8.145,6.821,9.465	c0.499,0.09,0.679-0.217,0.679-0.481c0-0.237-0.008-0.865-0.011-1.696c-2.775,0.602-3.361-1.338-3.361-1.338	c-0.452-1.152-1.107-1.459-1.107-1.459c-0.905-0.619,0.069-0.605,0.069-0.605c1.002,0.07,1.527,1.028,1.527,1.028	c0.89,1.524,2.336,1.084,2.902,0.829c0.091-0.645,0.351-1.085,0.635-1.334c-2.214-0.251-4.542-1.107-4.542-4.93	c0-1.087,0.389-1.979,1.024-2.675c-0.101-0.253-0.446-1.268,0.099-2.64c0,0,0.837-0.269,2.742,1.021	c0.798-0.221,1.649-0.332,2.496-0.336c0.849,0.004,1.701,0.115,2.496,0.336c1.906-1.291,2.742-1.021,2.742-1.021	c0.545,1.372,0.203,2.387,0.099,2.64c0.64,0.696,1.024,1.587,1.024,2.675c0,3.833-2.33,4.675-4.552,4.922	c0.355,0.308,0.675,0.916,0.675,1.846c0,1.334-0.012,2.41-0.012,2.737c0,0.267,0.178,0.577,0.687,0.479	C19.146,20.115,22,16.379,22,11.974C22,6.465,17.535,2,12.026,2z" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="link" iconlabel="Link">
    <g fill="currentColor" fill-rule="evenodd">
      <path
        d="M12.856 5.457l-.937.92a1.002 1.002 0 000 1.437 1.047 1.047 0 001.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 01.203 3.81l-2.903 2.852a2.646 2.646 0 01-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 00-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47" />
      <path
        d="M11.144 19.543l.937-.92a1.002 1.002 0 000-1.437 1.047 1.047 0 00-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 01-.203-3.81l2.903-2.852a2.646 2.646 0 013.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 00.357 6.82c1.893 1.517 4.695 1.226 6.422-.47" />
    </g>
  </symbol>
  <symbol viewBox="0 0 160 146" id="no-result" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient x1="14.22%" y1="85.365%" x2="85.257%" y2="14.651%" id="na">
        <stop stop-color="#C1C7D0" offset="56%" />
        <stop stop-color="#E9EBEF" stop-opacity=".5" offset="97%" />
      </linearGradient>
    </defs>
    <g fill-rule="nonzero" fill="none">
      <path
        d="M81.363 145.862c-.715 0-1.427.016-2.136.046a1.798 1.798 0 11-.077-3.593h.054a67.405 67.405 0 0013.58-1.452 1.8 1.8 0 11.766 3.516 71 71 0 01-12.187 1.483zm-11.874-.626c-.104.009-.21.009-.314 0a69.905 69.905 0 01-13.986-3.433 1.8 1.8 0 111.217-3.386 66.287 66.287 0 0013.26 3.264 1.797 1.797 0 01-.185 3.578l.008-.023zm33.156-3.57a1.796 1.796 0 01-.689-3.486 66.438 66.438 0 0012.249-6.016 1.808 1.808 0 012.761 1.466c.023.644-.3 1.25-.847 1.592a70.122 70.122 0 01-12.915 6.344c-.179.07-.367.112-.559.123v-.023zm-55.763-3.738a1.794 1.794 0 01-.903-.206 70.552 70.552 0 01-11.95-8.011 1.795 1.795 0 01-.238-2.53 1.801 1.801 0 012.534-.237 66.9 66.9 0 0011.346 7.59 1.795 1.795 0 01-.766 3.386l-.023.008zm-18.717-14.562a1.8 1.8 0 01-1.401-.588 70.33 70.33 0 01-8.506-11.596 1.796 1.796 0 011.543-2.709 1.802 1.802 0 011.566.89 66.752 66.752 0 008.068 11 1.794 1.794 0 01-1.27 3.003zm110.17-11.879a1.8 1.8 0 01-1.605-.868 1.794 1.794 0 01-.018-1.822 66.284 66.284 0 005.527-12.483 1.803 1.803 0 013.43 1.109 69.851 69.851 0 01-5.834 13.14 1.8 1.8 0 01-1.5.924zM15.54 103.293a1.8 1.8 0 01-1.761-1.124 69.74 69.74 0 01-3.981-13.805 1.797 1.797 0 01.608-1.693 1.803 1.803 0 012.937 1.051 66.182 66.182 0 003.827 13.094 1.794 1.794 0 01-1.607 2.477h-.023zm130.825-14.126a1.8 1.8 0 01-1.838-2.102 66.878 66.878 0 00.927-13.606v-.153a1.799 1.799 0 011.734-1.862 1.8 1.8 0 011.864 1.732v.153c.17 4.8-.15 9.605-.957 14.34a1.798 1.798 0 01-1.73 1.49v.008zM10.58 80.063a1.77 1.77 0 01-1.86-1.697v-.076a70.48 70.48 0 01.941-14.264 1.801 1.801 0 013.552.604 66.923 66.923 0 00-.895 13.53 1.828 1.828 0 01-1.738 1.903zm135.64-14.76a1.798 1.798 0 01-1.83-1.476 66.121 66.121 0 00-3.827-13.086 1.81 1.81 0 01.999-2.358 1.814 1.814 0 012.361.997 69.748 69.748 0 014.02 13.805 1.794 1.794 0 01-1.447 2.095l-.276.023zM13.833 56.565a1.794 1.794 0 01-1.776-2.293 69.882 69.882 0 015.819-13.147 1.802 1.802 0 013.13 1.78 66.284 66.284 0 00-5.519 12.476 1.799 1.799 0 01-1.654 1.184zm124.134-13.484a1.8 1.8 0 01-1.615-.886 66.722 66.722 0 00-8.084-10.992 1.795 1.795 0 01.872-3.1 1.8 1.8 0 011.77.684 70.33 70.33 0 018.52 11.58 1.794 1.794 0 01-1.486 2.707l.023.007zm-113.002-7.43a1.794 1.794 0 01-1.485-2.905 70.7 70.7 0 019.952-10.372 1.8 1.8 0 013.084.995 1.795 1.795 0 01-.788 1.741 67.127 67.127 0 00-9.408 9.846 1.8 1.8 0 01-1.355.696zM122.58 25.02c-.44.015-.871-.132-1.21-.413a66.977 66.977 0 00-11.353-7.59 1.797 1.797 0 01-.75-2.431 1.803 1.803 0 012.434-.75 70.607 70.607 0 0111.958 7.996 1.795 1.795 0 01-1.087 3.18l.008.008zm-80-5.275a1.795 1.795 0 01-1.026-3.317 70.084 70.084 0 0112.915-6.36 1.796 1.796 0 111.248 3.371 66.468 66.468 0 00-12.25 6.031 1.793 1.793 0 01-.887.275zm59.36-6.474a1.802 1.802 0 01-.665-.107 66.433 66.433 0 00-13.237-3.226 1.796 1.796 0 01-1.177-2.883 1.802 1.802 0 011.667-.679 69.99 69.99 0 0113.987 3.41 1.796 1.796 0 01-.544 3.493l-.03-.008zm-37.358-2.446a1.797 1.797 0 01-.436-3.554c4.705-.99 9.499-1.503 14.308-1.53a1.798 1.798 0 11.077 3.593h-.054a67.29 67.29 0 00-13.581 1.468 1.817 1.817 0 01-.314.023z"
        opacity=".3" fill="#B3BAC5" />
      <path
        d="M146.833 26.9a.398.398 0 01-.299-.429 1.3 1.3 0 01.046-.344c.037-.237.085-.471.145-.703a5.814 5.814 0 011.256-2.362 6.684 6.684 0 012.603-1.728l1.898-.764a3.25 3.25 0 002.106-2.224c.098-.377.129-.768.091-1.155a2.673 2.673 0 00-.36-1.116 3.12 3.12 0 00-.864-.932 4.068 4.068 0 00-1.386-.627 3.335 3.335 0 00-1.6-.069c-.456.1-.886.292-1.263.566a3.487 3.487 0 00-.919 1.04c-.248.409-.436.851-.559 1.314-.035.143-.066.275-.092.398a.612.612 0 01-.765.466l-2.948-.917a.604.604 0 01-.436-.635c0-.092.013-.183.038-.275.046-.26.1-.515.161-.764a7.303 7.303 0 011.171-2.454 6.787 6.787 0 012.044-1.858 7.449 7.449 0 012.772-.947 8.564 8.564 0 013.406.26 9.63 9.63 0 013.216 1.444 7.91 7.91 0 012.051 2.102c.49.75.809 1.598.934 2.485.124.857.074 1.73-.145 2.568a6.373 6.373 0 01-1.776 3.142 9.113 9.113 0 01-3.024 1.826l-1.6.604a3.92 3.92 0 00-1.684 1.055 4.377 4.377 0 00-.888 1.521.398.398 0 01-.483.253l-2.847-.742zm-2.343 4.486c.173-.699.624-1.298 1.248-1.659a2.576 2.576 0 012.051-.29 2.729 2.729 0 011.945 3.325 2.569 2.569 0 01-1.263 1.636 2.66 2.66 0 01-2.06.267 2.679 2.679 0 01-1.921-3.286v.007zM14.936 17.061a.397.397 0 01-.268-.443.9.9 0 01.069-.344c.055-.232.121-.462.199-.688a5.816 5.816 0 011.416-2.293 6.686 6.686 0 012.718-1.529l1.944-.642a3.252 3.252 0 002.251-2.087c.123-.37.18-.757.168-1.146a2.672 2.672 0 00-.283-1.14 3.12 3.12 0 00-.765-.985 4.067 4.067 0 00-1.34-.719 3.38 3.38 0 00-2.94.306c-.39.252-.726.58-.987.963a5.004 5.004 0 00-.758 1.666.612.612 0 01-.82.428l-2.855-1.1a.604.604 0 01-.39-.665c0-.092.02-.184.061-.276.061-.254.133-.51.214-.764a7.305 7.305 0 011.34-2.37 6.789 6.789 0 012.167-1.704A7.45 7.45 0 0118.9.764a8.563 8.563 0 013.377.49 9.628 9.628 0 013.115 1.658 7.907 7.907 0 011.907 2.24c.437.78.699 1.646.765 2.538a6.488 6.488 0 01-.321 2.553 6.374 6.374 0 01-1.99 3.012 9.115 9.115 0 01-3.14 1.62l-1.638.49a3.921 3.921 0 00-1.753.94 4.206 4.206 0 00-.559.665c-.168.24-.312.496-.429.764a.398.398 0 01-.497.222l-2.802-.895zm-2.641 4.342a2.654 2.654 0 011.355-1.575 2.576 2.576 0 012.067-.152 2.728 2.728 0 011.715 3.447 2.57 2.57 0 01-1.37 1.529 2.66 2.66 0 01-2.075.13 2.674 2.674 0 01-1.692-3.379zM10.25 138.646a.398.398 0 01-.49-.175l-.16-.314a7.126 7.126 0 01-.283-.657 5.809 5.809 0 01-.33-2.653 6.667 6.667 0 011.141-2.912l1.11-1.72c.653-.88.817-2.03.437-3.057a3.309 3.309 0 00-.59-1.002 2.679 2.679 0 00-.934-.71 3.127 3.127 0 00-1.248-.268 4.07 4.07 0 00-1.53.283 3.33 3.33 0 00-1.356.863 3.37 3.37 0 00-.658 1.223 3.48 3.48 0 00-.169 1.369 5 5 0 00.299 1.399c.051.137.102.262.153.374a.61.61 0 01-.367.833l-2.91.948a.605.605 0 01-.72-.275l-.114-.252a8.287 8.287 0 01-.298-.704 7.298 7.298 0 01-.467-2.69c.014-.929.22-1.845.604-2.69a7.43 7.43 0 011.692-2.363 8.554 8.554 0 012.94-1.735 9.636 9.636 0 013.46-.665 7.926 7.926 0 012.894.543 6.124 6.124 0 012.19 1.528 6.496 6.496 0 011.385 2.194 6.366 6.366 0 01.352 3.593 9.09 9.09 0 01-1.424 3.233l-.964 1.414a3.91 3.91 0 00-.766 1.827c-.03.288-.03.577 0 .864.026.298.083.593.169.88.018.19-.1.366-.284.42l-2.763 1.054zm.66 5.023a2.649 2.649 0 01.068-2.08 2.57 2.57 0 011.531-1.414 2.734 2.734 0 013.506 1.613c.26.67.227 1.42-.092 2.064-.299.654-.851 1.16-1.53 1.399a2.683 2.683 0 01-3.46-1.59l-.024.008z"
        opacity=".3" fill="#C1C7D0" />
      <path
        d="M115.108 102.88l-5.474-5.297-7.372 7.644 5.474 5.297a10.27 10.27 0 012.84 4.961 10.27 10.27 0 002.84 4.961l22.201 21.48a8.49 8.49 0 0011.996-.191 8.463 8.463 0 00-.191-11.978l-22.2-21.48a10.294 10.294 0 00-5.061-2.675 10.294 10.294 0 01-5.053-2.722z"
        fill="#CFD4DB" />
      <path
        d="M119.946 105.487a10.294 10.294 0 01-4.83-2.622l-1.67-1.613a5.32 5.32 0 00-5.157-1.276 5.3 5.3 0 00-2.214 8.92l1.669 1.613a10.27 10.27 0 012.778 4.732 44.71 44.71 0 009.424-9.754z"
        fill="#DFE1E5" style="mix-blend-mode: multiply" />
      <path
        d="M78.852 120.01c-24.332.175-44.259-19.261-44.654-43.554-.394-24.292 18.89-44.364 43.214-44.978a44.086 44.086 0 0131.556 12.46c12.881 12.455 16.982 31.43 10.39 48.08-6.592 16.65-22.578 27.698-40.506 27.992zM77.55 42.042c-16.104.26-29.78 11.844-32.666 27.666-2.886 15.822 5.823 31.476 20.802 37.388 14.978 5.913 32.053.438 40.783-13.077 8.73-13.515 6.684-31.305-4.888-42.49a33.566 33.566 0 00-24.03-9.487z"
        fill="url(#na)" />
      <path
        d="M91.805 65.906l-4.088-3.99a1.532 1.532 0 00-2.167 0l-7.464 7.644-7.655-7.506a1.532 1.532 0 00-2.167 0l-4.019 4.082a1.528 1.528 0 000 2.163l7.655 7.483-7.494 7.644a1.528 1.528 0 000 2.164l4.088 4.013a1.532 1.532 0 002.166 0l7.495-7.644 7.656 7.483a1.532 1.532 0 002.166 0l4.02-4.082a1.528 1.528 0 000-2.163l-7.656-7.483 7.494-7.644a1.528 1.528 0 00-.03-2.164z"
        fill="#C1C7D0" />
    </g>
  </symbol>
  <symbol id="no-image" width="32mm" height="32mm" viewBox="-1 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg">
    <defs id="defs1" />
    <g id="layer1" transform="translate(-83.896051,-125.65491)">
      <path style="fill:#b3b3b3"
        d="m 21.857968,287.45629 c -0.61983,-0.7217 -0.76673,-1.37602 -0.44979,-2.00354 0.42026,-0.83211 71.13445,-71.57492 72.01218,-72.04134 0.61561,-0.32712 0.85205,-0.33474 1.4528,-0.0468 1.07495,0.51521 1.50745,1.58657 1.01499,2.51422 -0.21469,0.4044 -16.44284,16.77895 -36.06256,36.38788 -34.12031,34.10156 -35.7135,35.65261 -36.62108,35.65261 -0.57581,0 -1.10522,-0.18204 -1.34654,-0.46302 z m 6.26325,-13.81486 c -1.91532,-0.21951 -2.89422,-0.80881 -3.58159,-2.15616 -0.49549,-0.97125 -0.51377,-1.7218 -0.50957,-20.92782 l 0.01878,-19.10484 c 3.3e-4,-0.33583 0.0897,-0.86591 0.228115,-1.17178 0.349266,-0.7718 0.937062,-1.70435 1.860937,-2.19596 0.87871,-0.46757 2.07526,-0.49056 25.52998,-0.49056 h 24.60807 l -13.15934,13.15533 -13.15934,13.15533 -1.39875,-1.38137 c -0.76931,-0.75976 -1.51407,-1.37957 -1.65501,-1.37735 -0.14095,0.002 -3.9472,3.69262 -8.45835,8.2009 l -8.20209,8.19689 2.84428,10e-4 c 1.56435,6.4e-4 2.84427,0.0922 2.84427,0.20357 0,0.21757 -5.96576,6.17177 -6.12326,6.1114 -0.052,-0.0199 -0.81132,-0.11835 -1.68748,-0.21876 z m 14.55465,-29.49047 c 1.76476,-1.34605 2.41005,-3.6557 1.57784,-5.64748 -0.83491,-1.99822 -2.37901,-3.04727 -4.48529,-3.04727 -2.10628,0 -3.65038,1.04905 -4.48529,3.04727 -0.549,1.31393 -0.51612,2.66234 0.0939,3.85189 1.04038,2.02871 2.2971,2.73127 4.69034,2.6221 1.30614,-0.0596 1.81395,-0.22049 2.60849,-0.82651 z m 1.4988,26.43274 3.08333,-3.03731 h 19.9341 19.93409 l -9.88307,-9.88571 c -8.63161,-8.63391 -9.84806,-9.94892 -9.60661,-10.38489 0.15205,-0.27456 4.65956,-4.8581 10.01668,-10.18566 l 9.74023,-9.68647 1.73507,0.18819 c 2.04979,0.22231 3.00348,0.77561 3.70413,2.149 0.4955,0.97125 0.51377,1.7218 0.50958,20.92781 l -0.0039,19.36566 c -6.1e-5,0.30639 -0.06394,0.7959 -0.18005,1.07927 -0.425781,1.03912 -1.083328,1.48428 -1.923901,2.02766 -0.87892,0.46768 -2.06952,0.49031 -25.53229,0.48516 l -24.61038,-0.005 z"
        id="path9" transform="matrix(0.37410969,0,0,0.37451976,77.947673,47.823435)" />
    </g>
  </symbol>
  <symbol viewBox="0 0 24 24" id="page" iconlabel="Pagina">
    <g fill="currentColor" fill-rule="evenodd">
      <rect x="8" y="6" width="8" height="2" rx="1" />
      <rect x="8" y="9" width="8" height="2" rx="1" />
      <rect x="8" y="12" width="4" height="2" rx="1" />
      <path
        d="M7 4v16h10V4H7zm-2-.01C5 2.892 5.897 2 7.006 2h9.988C18.102 2 19 2.898 19 3.99v16.02c0 1.099-.897 1.99-2.006 1.99H7.006A2.003 2.003 0 015 20.01V3.99z"
        fill-rule="nonzero" />
    </g>
  </symbol>
  <symbol viewBox="0 0 24 24" id="plus">
    <path
      d="M13 11V3.993A.997.997 0 0012 3c-.556 0-1 .445-1 .993V11H3.993A.997.997 0 003 12c0 .557.445 1 .993 1H11v7.007c0 .548.448.993 1 .993.556 0 1-.445 1-.993V13h7.007A.997.997 0 0021 12c0-.556-.445-1-.993-1H13z"
      fill="currentColor" fill-rule="evenodd" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="report" iconlabel="Trend">
    <g fill="currentColor">
      <path
        d="M21 17H4.995C4.448 17 4 16.548 4 15.991V6a1 1 0 10-2 0v9.991A3.004 3.004 0 004.995 19H21a1 1 0 000-2zm-3-8v3a1 1 0 002 0V8a1 1 0 00-1-1h-4a1 1 0 000 2h3z" />
      <path
        d="M13.293 13.707a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L14 11.586l-2.293-2.293a1 1 0 00-1.414 0l-4 4a1 1 0 001.414 1.414L11 11.414l2.293 2.293z" />
    </g>
  </symbol>

  <symbol clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="1.41421"
    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="excel2">
    <path
      d="m307.5 103.75h-73.334c-5.028 0-9.167 4.139-9.167 9.166v38.959l82.501 48.125 41.25 17.405 41.25-17.405v-48.125z"
      fill="#21a366" fill-rule="nonzero"></path>
    <path d="m224.999 151.875h82.501v48.125h-82.501z" fill="#107c41"></path>
    <path d="m380.834 103.75h-73.334v48.125h82.5v-38.959c0-5.027-4.139-9.166-9.166-9.166z" fill="#33c481"
      fill-rule="nonzero"></path>
    <path d="m307.5 200h-82.501v87.084c0 5.027 4.139 9.166 9.167 9.166h146.668c5.027 0 9.166-4.139 9.166-9.166v-38.959z"
      fill="#185c37" fill-rule="nonzero"></path>
    <path d="m307.5 200h82.5v48.125h-82.5z" fill="#107c41"></path>
    <g fill-rule="nonzero">
      <path
        d="m284.584 138.125h-59.584v130.625h59.584c5.022-.014 9.152-4.144 9.166-9.166v-112.293c-.014-5.022-4.144-9.152-9.166-9.166z"
        fill-opacity=".094118"></path>
      <g fill-opacity=".2">
        <path
          d="m277.709 145h-52.709v130.625h52.709c5.022-.014 9.152-4.144 9.166-9.166v-112.293c-.014-5.022-4.144-9.152-9.166-9.166z">
        </path>
        <path
          d="m277.709 145h-52.709v116.875h52.709c5.022-.014 9.152-4.144 9.166-9.166v-98.543c-.014-5.022-4.144-9.152-9.166-9.166z">
        </path>
        <path
          d="m270.834 145h-45.834v116.875h45.834c5.022-.014 9.152-4.144 9.166-9.166v-98.543c-.014-5.022-4.144-9.152-9.166-9.166z">
        </path>
      </g>
      <path
        d="m179.166 145h91.668c5.027 0 9.166 4.139 9.166 9.166v91.668c0 5.027-4.138 9.166-9.166 9.166h-91.668c-5.027 0-9.166-4.139-9.166-9.166v-91.668c0-5.027 4.139-9.166 9.166-9.166z"
        fill="#107c41"></path>
      <path
        d="m194.292 234.375 22.246-34.471-20.376-34.279h16.397l11.123 21.909c1.022 2.079 1.725 3.63 2.109 4.652h.144c.734-1.661 1.502-3.276 2.302-4.843l11.889-21.718h15.055l-20.904 34.087 21.431 34.663h-16.014l-12.849-24.067c-.605-1.023-1.118-2.099-1.534-3.212h-.191c-.376 1.091-.874 2.136-1.487 3.115l-13.232 24.164z"
        fill="#fff"></path>
    </g>
    <path d="m170 90h220v220h-220z" fill="none"></path>
  </symbol>
  <symbol viewBox="0 0 24 24" id="search">
    <path
      d="M16.436 15.085l3.94 4.01a1 1 0 01-1.425 1.402l-3.938-4.006a7.5 7.5 0 111.423-1.406zM10.5 16a5.5 5.5 0 100-11 5.5 5.5 0 000 11z"
      fill="currentColor" fill-rule="evenodd" />
  </symbol>
  <symbol viewBox="0 0 24 24" id="ship" iconlabel="Nave">
    <g fill="currentColor" fill-rule="evenodd">
      <path d="M6 12h8v-2H6v2zM4 8.99C4 8.445 4.456 8 5.002 8h9.996C15.55 8 16 8.451 16 8.99V14H4V8.99z"
        fill-rule="nonzero" />
      <path
        d="M6 7.005C6 5.898 6.898 5 7.998 5h2.004C11.106 5 12 5.894 12 7.005V10H6V7.005zm4 0V7H7.999c.005 0 .002.003.002.005V8h2v-.995z" />
      <path
        d="M4.5 17h13.994l1.002-3H4.14l.36 3zm-2.495-4.012A.862.862 0 012.883 12h18.393c.55 0 .857.417.681.944l-1.707 5.112c-.174.521-.758.944-1.315.944H3.725a1.149 1.149 0 01-1.118-.988l-.602-5.024z"
        fill-rule="nonzero" />
    </g>
  </symbol>
  <symbol viewBox="0 0 24 24" id="star">
    <path
      d="M15.673 14.042l3.673-3.58-5.076-.738L12 5.125l-2.27 4.6-5.076.737 3.673 3.58-.867 5.055L12 16.711l4.54 2.386-.867-5.055zM12 19.04l-4.505 2.37a1.546 1.546 0 01-2.244-1.63l.86-5.017-3.644-3.553a1.546 1.546 0 01.857-2.637l5.037-.732 2.252-4.564a1.546 1.546 0 012.774 0l2.252 4.564 5.037.732a1.546 1.546 0 01.857 2.637l-3.645 3.553.86 5.016a1.546 1.546 0 01-2.243 1.63L12 19.04z"
      fill="currentColor" />
  </symbol>
  <symbol viewBox="0 0 16 16" id="story" iconlabel="Storia" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(1 1)" fill="none" fill-rule="evenodd">
      <rect fill="#63BA3C" width="14" height="14" rx="2" />
      <path
        d="M9 3H5a1 1 0 00-1 1v6.5a.5.5 0 00.5.5.49.49 0 00.41-.231l.004.001L6.84 8.54a.2.2 0 01.32 0l1.926 2.23.004-.001A.49.49 0 009.5 11a.5.5 0 00.5-.5V4a1 1 0 00-1-1"
        fill="#FFF" />
    </g>
  </symbol>
  <symbol viewBox="0 0 16 16" id="task" iconlabel="Task" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(1 1)" fill="none" fill-rule="evenodd">
      <rect fill="#4BADE8" width="14" height="14" rx="2" />
      <path d="M6 9.5l4-5m-4 5l-2-2" stroke="#FFF" stroke-width="2" stroke-linecap="round" />
    </g>
  </symbol>
  <symbol viewBox="0 0 24 24" id="times" iconlabel="Chiudi">
    <path
      d="M12 10.586L6.707 5.293a1 1 0 00-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 001.414 1.414L12 13.414l5.293 5.293a1 1 0 001.414-1.414L13.414 12l5.293-5.293a1 1 0 10-1.414-1.414L12 10.586z" />
  </symbol>

  <symbol viewBox="0 0 24 24" id="maximize">
    <path
      d="M21 15.344L18.879 17.465 15.707 14.293 14.293 15.707 17.465 18.879 15.344 21 21 21zM3 8.656L5.121 6.535 8.293 9.707 9.707 8.293 6.535 5.121 8.656 3 3 3zM21 3L15.344 3 17.465 5.121 14.293 8.293 15.707 9.707 18.879 6.535 21 8.656zM3 21L8.656 21 6.535 18.879 9.707 15.707 8.293 14.293 5.121 17.465 3 15.344z" />
  </symbol>

  <symbol viewBox="0 0 24 24" id="spin" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12,22c5.421,0,10-4.579,10-10h-2c0,4.337-3.663,8-8,8s-8-3.663-8-8c0-4.336,3.663-8,8-8V2C6.579,2,2,6.58,2,12 C2,17.421,6.579,22,12,22z" />
  </symbol>

  <symbol id="folder" iconlabel="Cartella" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"
    enable-background="new 0 0 48 48">
    <path fill="#FFA000" d="M40,12H22l-4-4H8c-2.2,0-4,1.8-4,4v8h40v-4C44,13.8,42.2,12,40,12z" />
    <path fill="#FFCA28"
      d="M40,12H8c-2.2,0-4,1.8-4,4v20c0,2.2,1.8,4,4,4h32c2.2,0,4-1.8,4-4V16C44,13.8,42.2,12,40,12z" />
  </symbol>

  <symbol id="kanban" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" enable-background="new 0 0 48 48">
    <rect x="4" y="7" fill="#BBDEFB" width="40" height="34" />
    <rect x="9" y="12" fill="#3F51B5" width="30" height="5" />
    <g fill="#2196F3">
      <rect x="9" y="21" width="13" height="16" />
      <rect x="26" y="21" width="13" height="16" />
    </g>
  </symbol>

  <symbol id="todo_list" iconlabel="Lista" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"
    enable-background="new 0 0 48 48">
    <g fill="#3F51B5">
      <polygon points="17.8,18.1 10.4,25.4 6.2,21.3 4,23.5 10.4,29.9 20,20.3" />
      <polygon points="17.8,5.1 10.4,12.4 6.2,8.3 4,10.5 10.4,16.9 20,7.3" />
      <polygon points="17.8,31.1 10.4,38.4 6.2,34.3 4,36.5 10.4,42.9 20,33.3" />
    </g>
    <g fill="#90CAF9">
      <rect x="24" y="22" width="20" height="4" />
      <rect x="24" y="9" width="20" height="4" />
      <rect x="24" y="35" width="20" height="4" />
    </g>
  </symbol>

  <symbol id="new_issue" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" enable-background="new 0 0 48 48">
    <path fill="#90CAF9"
      d="M43,30V18c0-2.2-1.8-4-4-4H9c-2.2,0-4,1.8-4,4v12c0,2.2,1.8,4,4,4h30C41.2,34,43,32.2,43,30z M9,18h30v12 L9,30V18z" />
    <circle fill="#43A047" cx="38" cy="38" r="10" />
    <g fill="#fff">
      <rect x="32" y="36" width="12" height="4" />
      <rect x="36" y="32" width="4" height="12" />
    </g>
  </symbol>

  <symbol id="archive" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" enable-background="new 0 0 48 48">
    <path fill="#673AB7" d="M38,44H12V4h26c2.2,0,4,1.8,4,4v32C42,42.2,40.2,44,38,44z" />
    <path fill="#311B92" d="M10,4h2v40h-2c-2.2,0-4-1.8-4-4V8C6,5.8,7.8,4,10,4z" />
    <path fill="#fff"
      d="M36,24.2c-0.1,4.8-3.1,6.9-5.3,6.7c-0.6-0.1-2.1-0.1-2.9-1.6c-0.8,1-1.8,1.6-3.1,1.6c-2.6,0-3.3-2.5-3.4-3.1 c-0.1-0.7-0.2-1.4-0.1-2.2c0.1-1,1.1-6.5,5.7-6.5c2.2,0,3.5,1.1,3.7,1.3L30,27.2c0,0.3-0.2,1.6,1.1,1.6c2.1,0,2.4-3.9,2.4-4.6 c0.1-1.2,0.3-8.2-7-8.2c-6.9,0-7.9,7.4-8,9.2c-0.5,8.5,6,8.5,7.2,8.5c1.7,0,3.7-0.7,3.9-0.8l0.4,2c-0.3,0.2-2,1.1-4.4,1.1 c-2.2,0-10.1-0.4-9.8-10.8C16.1,23.1,17.4,14,26.6,14C35.8,14,36,22.1,36,24.2z M24.1,25.5c-0.1,1,0,1.8,0.2,2.3 c0.2,0.5,0.6,0.8,1.2,0.8c0.1,0,0.3,0,0.4-0.1c0.2-0.1,0.3-0.1,0.5-0.3c0.2-0.1,0.3-0.3,0.5-0.6c0.2-0.2,0.3-0.6,0.4-1l0.5-5.4 c-0.2-0.1-0.5-0.1-0.7-0.1c-0.5,0-0.9,0.1-1.2,0.3c-0.3,0.2-0.6,0.5-0.9,0.8c-0.2,0.4-0.4,0.8-0.6,1.3S24.2,24.8,24.1,25.5z" />
  </symbol>

  <symbol id="settings" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" enable-background="new 0 0 48 48">
    <path fill="#607D8B"
      d="M39.6,27.2c0.1-0.7,0.2-1.4,0.2-2.2s-0.1-1.5-0.2-2.2l4.5-3.2c0.4-0.3,0.6-0.9,0.3-1.4L40,10.8 c-0.3-0.5-0.8-0.7-1.3-0.4l-5,2.3c-1.2-0.9-2.4-1.6-3.8-2.2l-0.5-5.5c-0.1-0.5-0.5-0.9-1-0.9h-8.6c-0.5,0-1,0.4-1,0.9l-0.5,5.5 c-1.4,0.6-2.7,1.3-3.8,2.2l-5-2.3c-0.5-0.2-1.1,0-1.3,0.4l-4.3,7.4c-0.3,0.5-0.1,1.1,0.3,1.4l4.5,3.2c-0.1,0.7-0.2,1.4-0.2,2.2 s0.1,1.5,0.2,2.2L4,30.4c-0.4,0.3-0.6,0.9-0.3,1.4L8,39.2c0.3,0.5,0.8,0.7,1.3,0.4l5-2.3c1.2,0.9,2.4,1.6,3.8,2.2l0.5,5.5 c0.1,0.5,0.5,0.9,1,0.9h8.6c0.5,0,1-0.4,1-0.9l0.5-5.5c1.4-0.6,2.7-1.3,3.8-2.2l5,2.3c0.5,0.2,1.1,0,1.3-0.4l4.3-7.4 c0.3-0.5,0.1-1.1-0.3-1.4L39.6,27.2z M24,35c-5.5,0-10-4.5-10-10c0-5.5,4.5-10,10-10c5.5,0,10,4.5,10,10C34,30.5,29.5,35,24,35z" />
    <path fill="#455A64"
      d="M24,13c-6.6,0-12,5.4-12,12c0,6.6,5.4,12,12,12s12-5.4,12-12C36,18.4,30.6,13,24,13z M24,30 c-2.8,0-5-2.2-5-5c0-2.8,2.2-5,5-5s5,2.2,5,5C29,27.8,26.8,30,24,30z" />
  </symbol>

  <symbol id="excel" iconlabel="Excel" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"
    enable-background="new 0 0 48 48">
    <path fill="#90CAF9"
      d="M39,16v7h-6v-7h-2v7h-6v-7h-2v7h-7v2h7v6h-7v2h7v6h-7v2h25V16H39z M39,25v6h-6v-6H39z M25,25h6v6h-6V25z M25,33h6v6h-6V33z M33,39v-6h6v6H33z" />
    <polygon fill="#00BCD4" points="40,8 8,8 8,40 16,40 16,16 40,16" />
    <path fill="#0097A7"
      d="M7,7v34h10V17h24V7H7z M9,23v-6h6v6H9z M15,25v6H9v-6H15z M17,9h6v6h-6V9z M25,9h6v6h-6V9z M15,9v6H9V9H15z M9,39v-6h6v6H9z M39,15h-6V9h6V15z" />
  </symbol>

  <symbol id="offline" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <title>wifi-signal-off</title>
    <path
      d="M23.615 5.824c-3.236-2.291-7.264-3.662-11.612-3.662-1.406 0-2.778 0.143-4.103 0.416l0.131-0.022 1.012 1.339c0.888-0.148 1.911-0.233 2.955-0.233 0.001 0 0.002 0 0.004 0h-0c0.009-0 0.019-0 0.030-0 3.753 0 7.248 1.109 10.174 3.017l-0.072-0.044-5.299 7.568 0.951 1.258 5.842-8.343v-1.286z">
    </path>
    <path
      d="M3.869 0.75v1.027l1.213 1.605c-1.793 0.66-3.344 1.484-4.76 2.485l0.063-0.042-0.010 0.007v1.286l10.771 15.382h1.708l3.211-4.586 2.899 3.836h1.077v-1.062l-15.068-19.938zM15.115 16.657l-3.115 4.448-10.132-14.47c1.197-0.783 2.572-1.459 4.029-1.961l0.131-0.039z">
    </path>
  </symbol>

  <symbol id="home" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path
      d="M22.016 10.146l-9.309-8.564c-0.283-0.261-0.662-0.421-1.079-0.421-0.44 0-0.839 0.178-1.127 0.467l-9.001 9.001v12.621h8.25v-7.875h4.5v7.875h8.25v-12.658zM21 21.75h-5.25v-6.375c0-0.828-0.672-1.5-1.5-1.5v0h-4.5c-0.828 0-1.5 0.672-1.5 1.5v0 6.375h-5.25v-10.5l8.561-8.561c0.017-0.017 0.040-0.027 0.066-0.027 0.025 0 0.047 0.009 0.064 0.025l-0-0 9.309 8.564z">
    </path>
  </symbol>

  <symbol id="devices" iconlabel="Devices" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"
    enable-background="new 0 0 48 48">
    <path fill="#546E7A" d="M4,28V8c0-2.2,1.8-4,4-4h28c2.2,0,4,1.8,4,4v20c0,2.2-1.8,4-4,4H8C5.8,32,4,30.2,4,28z" />
    <path fill="#BBDEFB" d="M36,7H8C7.4,7,7,7.4,7,8v20c0,0.6,0.4,1,1,1h28c0.6,0,1-0.4,1-1V8C37,7.4,36.6,7,36,7z" />
    <path fill="#37474F" d="M38,33H6c-2.2,0-4-1.8-4-4v0h40v0C42,31.2,40.2,33,38,33z" />
    <path fill="#E38939"
      d="M24,40V16c0-2.2,1.8-4,4-4h12c2.2,0,4,1.8,4,4v24c0,2.2-1.8,4-4,4H28C25.8,44,24,42.2,24,40z" />
    <path fill="#FFF3E0"
      d="M40,15H28c-0.6,0-1,0.4-1,1v22c0,0.6,0.4,1,1,1h12c0.6,0,1-0.4,1-1V16C41,15.4,40.6,15,40,15z" />
    <circle fill="#A6642A" cx="34" cy="41.5" r="1.5" />
  </symbol>

  <symbol id="callcenter" iconlabel="callcenter" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"
    enable-background="new 0 0 48 48">
    <rect x="13" y="30" fill="#BF360C" width="22" height="12" />
    <g fill="#FFA726">
      <circle cx="10" cy="26" r="4" />
      <circle cx="38" cy="26" r="4" />
    </g>
    <path fill="#FFB74D"
      d="M39,19c0-12.7-30-8.3-30,0c0,1.8,0,8.2,0,10c0,8.3,6.7,15,15,15s15-6.7,15-15C39,27.2,39,20.8,39,19z" />
    <g fill="#784719">
      <circle cx="30" cy="26" r="2" />
      <circle cx="18" cy="26" r="2" />
    </g>
    <path fill="#FF5722"
      d="M24,2C15.5,2,3,7.8,3,35.6L13,42V24l16.8-9.8L35,21v21l10-8.2c0-5.6-0.9-29-15.4-29L28.2,2H24z" />
    <path fill="#757575"
      d="M45,24c-0.6,0-1,0.4-1,1v-7c0-8.8-7.2-16-16-16h-9c-0.6,0-1,0.4-1,1s0.4,1,1,1h9c7.7,0,14,6.3,14,14v10 c0,0.6,0.4,1,1,1s1-0.4,1-1v2c0,3.9-3.1,7-7,7H24c-0.6,0-1,0.4-1,1s0.4,1,1,1h13c5,0,9-4,9-9v-5C46,24.4,45.6,24,45,24z" />
    <g fill="#37474F">
      <path d="M45,22h-1c-1.1,0-2,0.9-2,2v4c0,1.1,0.9,2,2,2h1c1.1,0,2-0.9,2-2v-4C47,22.9,46.1,22,45,22z" />
      <circle cx="24" cy="38" r="2" />
    </g>
  </symbol>

  <symbol id="building" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" enable-background="new 0 0 48 48">
    <path fill="#90CAF9" d="M42,42H6V10c0-2.2,1.8-4,4-4h28c2.2,0,4,1.8,4,4V42z" />
    <rect x="6" y="42" fill="#64B5F6" width="36" height="2" />
    <g fill="#1565C0">
      <rect x="31" y="27" width="6" height="5" />
      <rect x="21" y="27" width="6" height="5" />
      <rect x="11" y="27" width="6" height="5" />
      <rect x="31" y="35" width="6" height="5" />
      <rect x="11" y="35" width="6" height="5" />
      <rect x="31" y="19" width="6" height="5" />
      <rect x="21" y="19" width="6" height="5" />
      <rect x="11" y="19" width="6" height="5" />
      <rect x="31" y="11" width="6" height="5" />
      <rect x="21" y="11" width="6" height="5" />
      <rect x="11" y="11" width="6" height="5" />
      <rect x="21" y="35" width="6" height="9" />
    </g>
  </symbol>

  <symbol id="delivery" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" enable-background="new 0 0 48 48">
    <path fill="#8BC34A" d="M43,36H29V14h10.6c0.9,0,1.6,0.6,1.9,1.4L45,26v8C45,35.1,44.1,36,43,36z" />
    <path fill="#388E3C" d="M29,36H5c-1.1,0-2-0.9-2-2V9c0-1.1,0.9-2,2-2h22c1.1,0,2,0.9,2,2V36z" />
    <g fill="#37474F">
      <circle cx="37" cy="36" r="5" />
      <circle cx="13" cy="36" r="5" />
    </g>
    <g fill="#78909C">
      <circle cx="37" cy="36" r="2" />
      <circle cx="13" cy="36" r="2" />
    </g>
    <path fill="#37474F"
      d="M41,25h-7c-0.6,0-1-0.4-1-1v-7c0-0.6,0.4-1,1-1h5.3c0.4,0,0.8,0.3,0.9,0.7l1.7,5.2c0,0.1,0.1,0.2,0.1,0.3V24 C42,24.6,41.6,25,41,25z" />
    <polygon fill="#DCEDC8" points="21.8,13.8 13.9,21.7 10.2,17.9 8,20.1 13.9,26 24,15.9" />
  </symbol>

  <symbol id="bag" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" enable-background="new 0 0 48 48">
    <path fill="#424242"
      d="M27,7h-6c-1.7,0-3,1.3-3,3v3h2v-3c0-0.6,0.4-1,1-1h6c0.6,0,1,0.4,1,1v3h2v-3C30,8.3,28.7,7,27,7z" />
    <path fill="#E65100"
      d="M40,43H8c-2.2,0-4-1.8-4-4V15c0-2.2,1.8-4,4-4h32c2.2,0,4,1.8,4,4v24C44,41.2,42.2,43,40,43z" />
    <path fill="#FF6E40" d="M40,28H8c-2.2,0-4-1.8-4-4v-9c0-2.2,1.8-4,4-4h32c2.2,0,4,1.8,4,4v9C44,26.2,42.2,28,40,28z" />
    <path fill="#FFF3E0" d="M26,26h-4c-0.6,0-1-0.4-1-1v-2c0-0.6,0.4-1,1-1h4c0.6,0,1,0.4,1,1v2C27,25.6,26.6,26,26,26z" />
  </symbol>

  <symbol id="trash" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" enable-background="new 0 0 48 48">
    <path fill="#B39DDB" d="M30.6,44H17.4c-2,0-3.7-1.4-4-3.4L9,11h30l-4.5,29.6C34.2,42.6,32.5,44,30.6,44z" />
    <path fill="#7E57C2" d="M38,13H10c-1.1,0-2-0.9-2-2v0c0-1.1,0.9-2,2-2h28c1.1,0,2,0.9,2,2v0C40,12.1,39.1,13,38,13z" />
  </symbol>

  <symbol id="tess" fill="none" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
    <path fill="#fff" fill-opacity=".01" d="M0 0h48v48H0z" />
    <path fill="#2F88FF" stroke="#000" stroke-width="4" stroke-linejoin="round" d="M13 10h28v34H13z" />
    <path d="M35 10V4H8a1 1 0 0 0-1 1v33h6" stroke="#000" stroke-width="4" stroke-linecap="round"
      stroke-linejoin="round" />
    <path d="M21 22h12M21 30h12" stroke="#fff" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
  </symbol>

  <symbol id="db_restore" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" enable-background="new 0 0 48 48">
    <g fill="#D1C4E9">
      <path d="M38,7H10C8.9,7,8,7.9,8,9v6c0,1.1,0.9,2,2,2h28c1.1,0,2-0.9,2-2V9C40,7.9,39.1,7,38,7z" />
      <path d="M38,19H10c-1.1,0-2,0.9-2,2v6c0,1.1,0.9,2,2,2h28c1.1,0,2-0.9,2-2v-6C40,19.9,39.1,19,38,19z" />
      <path d="M38,31H10c-1.1,0-2,0.9-2,2v6c0,1.1,0.9,2,2,2h28c1.1,0,2-0.9,2-2v-6C40,31.9,39.1,31,38,31z" />
    </g>
    <g fill="#2196F3">
      <polygon points="31,30 38,35.6 38,24.4" />
      <path
        d="M38,28c-0.3,0-0.7,0-1,0.1v4c0.3-0.1,0.7-0.1,1-0.1c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6 c0-0.3,0-0.6,0.1-0.9l-3.4-2.7C28.3,35.5,28,36.7,28,38c0,5.5,4.5,10,10,10s10-4.5,10-10S43.5,28,38,28z" />
    </g>
  </symbol>

  <symbol id="workflow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" enable-background="new 0 0 48 48">
    <path fill="#90CAF9" d="M33,9H11v4h22c1.1,0,2,0.9,2,2v20H23v4h16V15C39,11.7,36.3,9,33,9z" />
    <rect x="6" y="6" fill="#D81B60" width="10" height="10" />
    <g fill="#2196F3">
      <rect x="32" y="17" width="10" height="10" />
      <rect x="16" y="32" width="10" height="10" />
      <circle cx="26" cy="11" r="5" />
      <circle cx="37" cy="37" r="5" />
    </g>
  </symbol>

  <symbol id="user" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" enable-background="new 0 0 48 48">
    <polygon fill="#FF9800" points="24,37 19,31 19,25 29,25 29,31" />
    <g fill="#FFA726">
      <circle cx="33" cy="19" r="2" />
      <circle cx="15" cy="19" r="2" />
    </g>
    <path fill="#FFB74D" d="M33,13c0-7.6-18-5-18,0c0,1.1,0,5.9,0,7c0,5,4,9,9,9s9-4,9-9C33,18.9,33,14.1,33,13z" />
    <path fill="#424242"
      d="M24,4c-6.1,0-10,4.9-10,11c0,0.8,0,2.3,0,2.3l2,1.7v-5l12-4l4,4v5l2-1.7c0,0,0-1.5,0-2.3c0-4-1-8-6-9l-1-2 H24z" />
    <g fill="#784719">
      <circle cx="28" cy="19" r="1" />
      <circle cx="20" cy="19" r="1" />
    </g>
    <polygon fill="#fff" points="24,43 19,31 24,32 29,31" />
    <polygon fill="#D32F2F" points="23,35 22.3,39.5 24,43.5 25.7,39.5 25,35 26,34 24,32 22,34" />
    <path fill="#546E7A" d="M29,31L29,31l-5,12l-5-12c0,0-11,2-11,13h32C40,33,29,31,29,31z" />
  </symbol>

  <symbol id="reload" viewBox="64 64 896 896" fill="#3b4747" width="1em" height="1em" data-icon="reload">
    <path
      d="M909.1 209.3l-56.4 44.1C775.8 155.1 656.2 92 521.9 92 290 92 102.3 279.5 102 511.5 101.7 743.7 289.8 932 521.9 932c181.3 0 335.8-115 394.6-276.1 1.5-4.2-.7-8.9-4.9-10.3l-56.7-19.5a8 8 0 00-10.1 4.8c-1.8 5-3.8 10-5.9 14.9-17.3 41-42.1 77.8-73.7 109.4A344.77 344.77 0 01655.9 829c-42.3 17.9-87.4 27-133.8 27-46.5 0-91.5-9.1-133.8-27A341.5 341.5 0 01279 755.2a342.16 342.16 0 01-73.7-109.4c-17.9-42.4-27-87.4-27-133.9s9.1-91.5 27-133.9c17.3-41 42.1-77.8 73.7-109.4 31.6-31.6 68.4-56.4 109.3-73.8 42.3-17.9 87.4-27 133.8-27 46.5 0 91.5 9.1 133.8 27a341.5 341.5 0 01109.3 73.8c9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47a8 8 0 003 14.1l175.6 43c5 1.2 9.9-2.6 9.9-7.7l.8-180.9c-.1-6.6-7.8-10.3-13-6.2z">
    </path>
  </symbol>

  <symbol id="add" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" enable-background="new 0 0 48 48">
    <circle fill="#4CAF50" cx="24" cy="24" r="21" />
    <g fill="#fff">
      <rect x="21" y="14" width="6" height="20" />
      <rect x="14" y="21" width="20" height="6" />
    </g>
  </symbol>

  <symbol id="expand" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" enable-background="new 0 0 48 48">
    <polygon fill="#2196F3" points="43,17.1 39.9,14 24,29.9 8.1,14 5,17.1 24,36" />
  </symbol>

  <symbol id="next" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" enable-background="new 0 0 48 48">
    <polygon fill="#2196F3" points="17.1,5 14,8.1 29.9,24 14,39.9 17.1,43 36,24" />
  </symbol>

  <symbol id="collapse" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" enable-background="new 0 0 48 48">
    <polygon fill="#2196F3" points="5,30.9 8.1,34 24,18.1 39.9,34 43,30.9 24,12" />
  </symbol>

  <symbol id="prev" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" enable-background="new 0 0 48 48">
    <polygon fill="#2196F3" points="30.9,43 34,39.9 18.1,24 34,8.1 30.9,5 12,24" />
  </symbol>

  <symbol id="calendar" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" enable-background="new 0 0 48 48">
    <path fill="#CFD8DC" d="M5,38V14h38v24c0,2.2-1.8,4-4,4H9C6.8,42,5,40.2,5,38z" />
    <path fill="#F44336" d="M43,10v6H5v-6c0-2.2,1.8-4,4-4h30C41.2,6,43,7.8,43,10z" />
    <g fill="#B71C1C">
      <circle cx="33" cy="10" r="3" />
      <circle cx="15" cy="10" r="3" />
    </g>
    <g fill="#B0BEC5">
      <path d="M33,3c-1.1,0-2,0.9-2,2v5c0,1.1,0.9,2,2,2s2-0.9,2-2V5C35,3.9,34.1,3,33,3z" />
      <path d="M15,3c-1.1,0-2,0.9-2,2v5c0,1.1,0.9,2,2,2s2-0.9,2-2V5C17,3.9,16.1,3,15,3z" />
    </g>
    <g fill="#90A4AE">
      <rect x="13" y="20" width="4" height="4" />
      <rect x="19" y="20" width="4" height="4" />
      <rect x="25" y="20" width="4" height="4" />
      <rect x="31" y="20" width="4" height="4" />
      <rect x="13" y="26" width="4" height="4" />
      <rect x="19" y="26" width="4" height="4" />
      <rect x="25" y="26" width="4" height="4" />
      <rect x="31" y="26" width="4" height="4" />
      <rect x="13" y="32" width="4" height="4" />
      <rect x="19" y="32" width="4" height="4" />
      <rect x="25" y="32" width="4" height="4" />
      <rect x="31" y="32" width="4" height="4" />
    </g>
  </symbol>

  <symbol id="external_tasks" version="1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"
    enable-background="new 0 0 48 48">
    <path fill="#FFCCBC" d="M7,40V8c0-2.2,1.8-4,4-4h24c2.2,0,4,1.8,4,4v32c0,2.2-1.8,4-4,4H11C8.8,44,7,42.2,7,40z" />
    <g fill="#FF5722">
      <polygon points="42.7,24 32,33 32,15" />
      <rect x="14" y="21" width="23" height="6" />
    </g>
  </symbol>

  <symbol id="gisfo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.933 16.933">
    <g style="font-size:3.175px;stroke-width:.264583;fill:#fd7d21">
      <path
        d="M100.9 145.06a1.908 1.908 0 0 0-1.248.243 1.833 1.833 0 0 0-.916 1.283 2.023 2.023 0 0 0 .223 1.496c.276.478.69.803 1.225.959a1.904 1.904 0 0 0 1.53-.18c.426-.245.729-.613.9-1.088a1.828 1.828 0 0 0-.155-1.562l-.059-.102-1.629.94.06.101.25.434.933-.537c.027.18.049.361-.028.572v.002c-.111.326-.295.557-.562.711a1.3 1.3 0 0 1-1.082.125 1.433 1.433 0 0 1-.836-.676 1.437 1.437 0 0 1-.162-1.078c.084-.387.285-.667.625-.863a1.33 1.33 0 0 1 .691-.174c.222.008.415.069.588.184l.06.039.602-.346-.129-.11c-.23-.194-.525-.316-.877-.372h-.002z"
        transform="matrix(4.19177 0 0 4.1452 -413.65 -601.22)" aria-label="G" />
    </g>
  </symbol>

  <symbol id="olo" xmlns="http://www.w3.org/2000/svg" viewBox="1.714 1.714 24 24">
    <path
      d="M22.286 1.714H5.143c-0.474 0 -0.857 0.383 -0.857 0.857v22.286c0 0.474 0.383 0.857 0.857 0.857h17.143c0.474 0 0.857 -0.383 0.857 -0.857V2.571c0 -0.474 -0.383 -0.857 -0.857 -0.857zm-16.071 1.929h15v5.571H6.214V3.643zm15 12.857H6.214V10.929h15v5.571zm0 7.286H6.214V18.214h15v5.571zM13.286 5.571H8.357c-0.118 0 -0.214 0.096 -0.214 0.214v1.286c0 0.118 0.096 0.214 0.214 0.214h4.929c0.118 0 0.214 -0.096 0.214 -0.214v-1.286c0 -0.118 -0.096 -0.214 -0.214 -0.214zM8.357 14.571h4.929c0.118 0 0.214 -0.096 0.214 -0.214v-1.286c0 -0.118 -0.096 -0.214 -0.214 -0.214H8.357c-0.118 0 -0.214 0.096 -0.214 0.214v1.286c0 0.118 0.096 0.214 0.214 0.214zm8.786 6.536a1.071 1.071 0 1 0 2.143 0 1.071 1.071 0 1 0 -2.143 0z" />
  </symbol>

  <symbol id="highest" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.942 8.73617C23.2088 7.97613 24.7913 7.97612 26.058 8.73617L45.5435 20.4275C46.9643 21.2799 47.4249 23.1227 46.5725 24.5434C45.7201 25.9642 43.8773 26.4249 42.4565 25.5724L24 14.4985L5.54351 25.5724C4.12277 26.4249 2.27999 25.9642 1.42755 24.5434C0.575103 23.1227 1.0358 21.2799 2.45654 20.4275L21.942 8.73617L23.4855 11.3086L21.942 8.73617Z"
      fill="#96092B" />
    <path
      d="M21.942 22.7362C23.2088 21.9761 24.7913 21.9761 26.058 22.7362L24.5145 25.3086L26.058 22.7362L45.5435 34.4275C46.9643 35.2799 47.4249 37.1227 46.5725 38.5434C45.7201 39.9642 43.8773 40.4249 42.4565 39.5724L24 28.4985L5.54351 39.5724C4.12277 40.4249 2.27999 39.9642 1.42755 38.5434C0.575103 37.1227 1.0358 35.2799 2.45654 34.4275L21.942 22.7362Z"
      fill="#DB0B3D" />
  </symbol>
  <symbol id="high" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.942 15.7362C23.2087 14.9761 24.7912 14.9761 26.058 15.7362L24.5145 18.3086L26.058 15.7362L45.5435 27.4275C46.9642 28.2799 47.4249 30.1227 46.5725 31.5434C45.72 32.9642 43.8773 33.4249 42.4565 32.5724L24 21.4985L5.54348 32.5724C4.12274 33.4249 2.27996 32.9642 1.42752 31.5434C0.575072 30.1227 1.03577 28.2799 2.45651 27.4275L21.942 15.7362Z"
      fill="#DB0B3D" />
  </symbol>
  <symbol id="medium" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 18C1 16.3431 2.34315 15 4 15L44 15C45.6569 15 47 16.3432 47 18C47 19.6569 45.6569 21 44 21L4 21C2.34314 21 0.999999 19.6569 1 18Z"
      fill="#F3881D" />
    <path
      d="M1 29.8572C1 28.2003 2.34315 26.8572 4 26.8572L44 26.8572C45.6569 26.8572 47 28.2004 47 29.8572C47 31.5141 45.6569 32.8572 44 32.8572L4 32.8572C2.34314 32.8572 0.999999 31.514 1 29.8572Z"
      fill="#F3881D" />
  </symbol>
  <symbol id="low" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M26.058 32.2638C24.7913 33.0239 23.2088 33.0239 21.942 32.2638L23.4855 29.6914L21.942 32.2638L2.45652 20.5725C1.03578 19.7201 0.575082 17.8773 1.42753 16.4566C2.27997 15.0358 4.12275 14.5751 5.54349 15.4276L24 26.5015L42.4565 15.4276C43.8773 14.5751 45.72 15.0358 46.5725 16.4566C47.4249 17.8773 46.9642 19.7201 45.5435 20.5725L26.058 32.2638Z"
      fill="#008FC1" />
  </symbol>
  <symbol id="lowest" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M26.058 39.2637C24.7913 40.0237 23.2088 40.0237 21.942 39.2637L23.4855 36.6912L21.942 39.2637L2.45652 27.5724C1.03578 26.72 0.575082 24.8772 1.42753 23.4564C2.27997 22.0357 4.12275 21.575 5.54349 22.4274L24 33.5014L42.4565 22.4275C43.8773 21.575 45.72 22.0357 46.5725 23.4564C47.4249 24.8772 46.9642 26.72 45.5435 27.5724L26.058 39.2637Z"
      fill="#00576B" />
    <path
      d="M26.058 25.2637C24.7913 26.0237 23.2088 26.0237 21.942 25.2637L23.4855 22.6912L21.942 25.2637L2.45652 13.5724C1.03578 12.72 0.575082 10.8772 1.42753 9.45644C2.27997 8.0357 4.12275 7.575 5.54349 8.42745L24 19.5014L42.4565 8.42745C43.8773 7.57501 45.72 8.0357 46.5725 9.45644C47.4249 10.8772 46.9642 12.72 45.5435 13.5724L26.058 25.2637Z"
      fill="#008FC1" />
  </symbol>

  <symbol id="on_going" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M38.0829 22.5535H16.3523V25.4407H38.0829L27.6487 38.485L29.9045 40.2923L42.2231 24.9038L42.481 24.5187L42.4521 24.4938C42.537 24.2608 42.5605 24.0099 42.5204 23.7652C42.4803 23.5205 42.3779 23.2902 42.2231 23.0965L29.9045 7.70776L27.6487 9.51341L38.0829 22.5535Z" />
    <path d="M5 1L5 47H7.88715L7.88715 1H5Z" />
  </symbol>
  <symbol id="slack" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M46.5916 23.8738C46.6107 18.288 44.5782 12.8896 40.8799 8.70334C37.1817 4.5171 32.0751 1.83443 26.5296 1.16457C20.9841 0.4947 15.3856 1.88427 10.7969 5.0695C6.20827 8.25473 2.94881 13.0139 1.63729 18.4436C0.325771 23.8733 1.05349 29.5955 3.6823 34.5241C6.31112 39.4527 10.658 43.2445 15.8979 45.1798C21.1378 47.1151 26.9058 47.0592 32.1072 45.0226C37.3085 42.986 41.5811 39.1106 44.1138 34.1319V47H46.5916V24.6997H46.542C46.542 24.4189 46.5916 24.1546 46.5916 23.8738ZM23.8783 34.198C21.8364 34.198 19.8403 33.5925 18.1425 32.458C16.4447 31.3236 15.1214 29.7112 14.34 27.8247C13.5586 25.9382 13.3541 23.8623 13.7525 21.8596C14.1509 19.8569 15.1342 18.0173 16.578 16.5735C18.0219 15.1296 19.8615 14.1463 21.8642 13.748C23.8669 13.3496 25.9427 13.5541 27.8292 14.3355C29.7157 15.1169 31.3282 16.4402 32.4626 18.138C33.597 19.8358 34.2025 21.8319 34.2025 23.8738C34.2017 26.6117 33.1137 29.2372 31.1777 31.1731C29.2417 33.1091 26.6162 34.1971 23.8783 34.198ZM22.6394 11.1379C19.474 11.4441 16.536 12.9182 14.3983 15.2727C12.2605 17.6273 11.0762 20.6936 11.0762 23.8738C11.0762 27.054 12.2605 30.1203 14.3983 32.4748C16.536 34.8294 19.474 36.3035 22.6394 36.6097V39.0875C18.8165 38.7787 15.25 37.042 12.6495 34.223C10.049 31.4039 8.60509 27.7091 8.60509 23.8738C8.60509 20.0384 10.049 16.3437 12.6495 13.5246C15.25 10.7056 18.8165 8.96885 22.6394 8.66004V11.1379ZM25.1172 36.6097C28.2827 36.3035 31.2207 34.8294 33.3584 32.4748C35.4962 30.1203 36.6805 27.054 36.6805 23.8738C36.6805 20.6936 35.4962 17.6273 33.3584 15.2727C31.2207 12.9182 28.2827 11.4441 25.1172 11.1379V8.66004C28.9401 8.96885 32.5066 10.7056 35.1072 13.5246C37.7077 16.3437 39.1516 20.0384 39.1516 23.8738C39.1516 27.7091 37.7077 31.4039 35.1072 34.223C32.5066 37.042 28.9401 38.7787 25.1172 39.0875V36.6097ZM3.6429 23.8738C3.65005 18.7263 5.61861 13.7751 9.14783 10.028C12.6771 6.28087 17.5016 4.01957 22.6394 3.70443V6.18223C18.1562 6.48874 13.9566 8.48587 10.8894 11.7699C7.82212 15.054 6.11609 19.3801 6.11609 23.8738C6.11609 28.3675 7.82212 32.6935 10.8894 35.9776C13.9566 39.2617 18.1562 41.2588 22.6394 41.5653V44.0431C17.5016 43.728 12.6771 41.4667 9.14783 37.7196C5.61861 33.9725 3.65005 29.0212 3.6429 23.8738ZM25.1172 44.0431V41.5653C29.6004 41.2588 33.8001 39.2617 36.8673 35.9776C39.9345 32.6935 41.6406 28.3675 41.6406 23.8738C41.6406 19.3801 39.9345 15.054 36.8673 11.7699C33.8001 8.48587 29.6004 6.48874 25.1172 6.18223V3.70443C30.2572 4.01312 35.0853 6.2725 38.6155 10.0211C42.1458 13.7697 44.1116 18.7246 44.1116 23.8738C44.1116 29.023 42.1458 33.9779 38.6155 37.7265C35.0853 41.4751 30.2572 43.7345 25.1172 44.0431Z" />
  </symbol>
  <symbol id="capture-photo" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.8851 31.4144C19.855 28.7266 20.6244 26.0905 22.0957 23.841C23.567 21.5915 25.6737 19.8301 28.1483 18.7806C30.6229 17.731 33.3536 17.4408 35.9935 17.9466C38.6334 18.4524 41.0634 19.7315 42.9747 21.6214C44.8861 23.5113 46.1925 25.9267 46.7281 28.5607C47.2637 31.1948 47.0043 33.9286 45.9827 36.4148C44.9612 38.9011 43.2237 41.0276 40.9909 42.5242C38.7581 44.0208 36.1309 44.8199 33.443 44.8201C29.8686 44.8361 26.4339 43.4337 23.8922 40.9205C21.3505 38.4074 19.9094 34.9887 19.8851 31.4144ZM21.895 31.4144C21.8697 33.7032 22.5254 35.948 23.7787 37.8634C25.0319 39.7789 26.8262 41.2786 28.9337 42.1721C31.0411 43.0655 33.3666 43.3124 35.6147 42.8814C37.8627 42.4504 39.932 41.3609 41.5595 39.7513C43.187 38.1417 44.2994 36.0847 44.7554 33.8416C45.2113 31.5984 44.9902 29.2704 44.1202 27.1531C43.2501 25.0359 41.7704 23.2251 39.869 21.9506C37.9676 20.6762 35.7302 19.9957 33.4412 19.9955C30.3976 19.9838 27.4734 21.179 25.3094 23.3194C23.1455 25.4598 21.9165 28.3708 21.895 31.4144ZM32.4345 39.1337V32.4105H25.6335V30.4236H32.4363V23.7004H34.4391V30.4236H41.2507V32.4122H34.4391V39.1354L32.4345 39.1337ZM2.00494 32.437C1.73996 32.4379 1.48541 32.3338 1.29705 32.1475C1.10869 31.9611 1.00187 31.7077 1 31.4427L1 8.7678C1.00234 8.50329 1.10942 8.2505 1.29778 8.06479C1.48614 7.87908 1.74043 7.7756 2.00494 7.77701H7.54628L10.8566 3.39809C10.9507 3.27429 11.0722 3.17394 11.2115 3.10488C11.3509 3.03582 11.5043 2.99993 11.6598 3H23.728C23.8835 2.99979 24.037 3.03563 24.1763 3.1047C24.3157 3.17377 24.4372 3.27419 24.5312 3.39809L27.8539 7.77701H33.3775C33.6428 7.7756 33.8978 7.87951 34.0866 8.06593C34.2753 8.25236 34.3824 8.50606 34.3842 8.77134V15.9917C34.0693 15.9722 33.7561 15.9439 33.4359 15.9439C33.0821 15.9439 32.7282 15.974 32.3743 15.997V9.76213H3.01165V30.4484H17.8487C17.8275 30.7686 17.7992 31.0853 17.7992 31.4126C17.7992 31.7399 17.8275 32.0955 17.8505 32.437H2.00494ZM10.0516 7.77701H25.3398L23.2273 4.98865H12.1641L10.0516 7.77701ZM10.0516 20.1088C10.0718 18.2492 10.7689 16.4607 12.0125 15.0779C13.256 13.6951 14.9607 12.8127 16.8077 12.5959C18.6547 12.379 20.5175 12.8425 22.0475 13.8997C23.5775 14.9568 24.6699 16.5352 25.1204 18.3395C24.4769 18.7401 23.8632 19.1866 23.2839 19.6753C23.2083 18.5831 22.8152 17.5368 22.1528 16.6652C21.4904 15.7935 20.5877 15.1344 19.5556 14.7691C18.5236 14.4037 17.4073 14.348 16.344 14.6088C15.2807 14.8696 14.3168 15.4355 13.571 16.2368C12.8251 17.0382 12.3297 18.0402 12.1458 19.1194C11.9619 20.1987 12.0974 21.3081 12.5358 22.3113C12.9741 23.3145 13.6962 24.1677 14.6131 24.7659C15.53 25.3642 16.6017 25.6813 17.6965 25.6784C18.1318 25.6745 18.5652 25.6204 18.9881 25.5174C18.7052 26.2072 18.4734 26.9168 18.2946 27.6405C18.0946 27.6565 17.8982 27.6724 17.6965 27.6724C15.6794 27.6823 13.7409 26.8907 12.3073 25.4716C10.8737 24.0526 10.0623 22.1224 10.0516 20.1052V20.1088Z"/>
  </symbol>

  <symbol id="factory" version="1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"
    enable-background="new 0 0 48 48">
    <path fill="#BF360C" d="M41.2,5h-7.3L32,43h11L41.2,5z" />
    <path fill="#E64A19" d="M33,23h-4v-6l-12,6v-6L5,23v20h28V23z" />
    <rect x="9" y="27" fill="#FFC107" width="4" height="4" />
    <rect x="17" y="27" fill="#FFC107" width="4" height="4" />
    <rect x="25" y="27" fill="#FFC107" width="4" height="4" />
    <rect x="9" y="35" fill="#FFC107" width="4" height="4" />
    <rect x="17" y="35" fill="#FFC107" width="4" height="4" />
    <rect x="25" y="35" fill="#FFC107" width="4" height="4" />
  </symbol>

  <symbol id="headquarter" version="1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"
    enable-background="new 0 0 48 48">
    <polygon fill="#C5CAE9" points="42,42 6,42 6,9 24,2 42,9" />
    <rect x="6" y="42" fill="#9FA8DA" width="36" height="2" />
    <rect x="20" y="35" fill="#BF360C" width="8" height="9" />
    <g fill="#1565C0">
      <rect x="31" y="27" width="6" height="5" />
      <rect x="21" y="27" width="6" height="5" />
      <rect x="11" y="27" width="6" height="5" />
      <rect x="31" y="35" width="6" height="5" />
      <rect x="11" y="35" width="6" height="5" />
      <rect x="31" y="19" width="6" height="5" />
      <rect x="21" y="19" width="6" height="5" />
      <rect x="11" y="19" width="6" height="5" />
      <rect x="31" y="11" width="6" height="5" />
      <rect x="21" y="11" width="6" height="5" />
      <rect x="11" y="11" width="6" height="5" />
    </g>
  </symbol>

  <symbol id="deployment" version="1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"
    enable-background="new 0 0 48 48">
    <path fill="#B0BEC5" d="M37,42H5V32h32c2.8,0,5,2.2,5,5v0C42,39.8,39.8,42,37,42z" />
    <path fill="#37474F"
      d="M10,34c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3S11.7,34,10,34z M10,38c-0.6,0-1-0.4-1-1c0-0.6,0.4-1,1-1 s1,0.4,1,1C11,37.6,10.6,38,10,38z" />
    <path fill="#37474F"
      d="M19,34c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3S20.7,34,19,34z M19,38c-0.6,0-1-0.4-1-1c0-0.6,0.4-1,1-1 s1,0.4,1,1C20,37.6,19.6,38,19,38z" />
    <path fill="#37474F"
      d="M37,34c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3S38.7,34,37,34z M37,38c-0.6,0-1-0.4-1-1c0-0.6,0.4-1,1-1 s1,0.4,1,1C38,37.6,37.6,38,37,38z" />
    <path fill="#37474F"
      d="M28,34c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3S29.7,34,28,34z M28,38c-0.6,0-1-0.4-1-1c0-0.6,0.4-1,1-1 s1,0.4,1,1C29,37.6,28.6,38,28,38z" />
    <path fill="#FF9800"
      d="M35,31H11c-1.1,0-2-0.9-2-2V7c0-1.1,0.9-2,2-2h24c1.1,0,2,0.9,2,2v22C37,30.1,36.1,31,35,31z" />
    <path fill="#8A5100"
      d="M26.5,13h-7c-0.8,0-1.5-0.7-1.5-1.5v0c0-0.8,0.7-1.5,1.5-1.5h7c0.8,0,1.5,0.7,1.5,1.5v0 C28,12.3,27.3,13,26.5,13z" />
    <path fill="#607D8B" d="M37,31H5v2h32c2.2,0,4,1.8,4,4s-1.8,4-4,4H5v2h32c3.3,0,6-2.7,6-6S40.3,31,37,31z" />
  </symbol>

  <symbol id="control" version="1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"
    enable-background="new 0 0 48 48">
    <polygon fill="#90CAF9" points="33,42 5,42 5,4 24,4 33,13" />
    <polygon fill="#E1F5FE" points="31.5,14 23,14 23,5.5" />
    <rect x="38.3" y="34.8" transform="matrix(.707 -.707 .707 .707 -17.177 40.055)" fill="#616161" width="2.8"
      height="12" />
    <circle fill="#616161" cx="28" cy="29" r="11" />
    <circle fill="#90CAF9" cx="28" cy="29" r="9" />
    <rect x="39.5" y="37.6" transform="matrix(.707 -.707 .707 .707 -17.661 41.223)" fill="#37474F" width="2.8"
      height="8.7" />
    <g fill="#1976D2">
      <path d="M30,31h-9.7c0.4,1.6,1.3,3,2.5,4H30V31z" />
      <path d="M20.3,27H30v-4h-7.3C21.5,24,20.7,25.4,20.3,27z" />
      <path d="M20.1,20H11v2h7.3C18.8,21.3,19.4,20.6,20.1,20z" />
      <path d="M17.1,24H11v2h5.4C16.6,25.3,16.8,24.6,17.1,24z" />
      <path d="M16,29c0-0.3,0-0.7,0.1-1H11v2h5.1C16,29.7,16,29.3,16,29z" />
      <path d="M16.4,32H11v2h6.1C16.8,33.4,16.6,32.7,16.4,32z" />
    </g>
  </symbol>

  <symbol id="shop" version="1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"
    enable-background="new 0 0 48 48">
    <rect x="5" y="19" fill="#CFD8DC" width="38" height="19" />
    <rect x="5" y="38" fill="#B0BEC5" width="38" height="4" />
    <rect x="27" y="24" fill="#455A64" width="12" height="18" />
    <rect x="9" y="24" fill="#E3F2FD" width="14" height="11" />
    <rect x="10" y="25" fill="#1E88E5" width="12" height="9" />
    <path fill="#90A4AE"
      d="M36.5,33.5c-0.3,0-0.5,0.2-0.5,0.5v2c0,0.3,0.2,0.5,0.5,0.5S37,36.3,37,36v-2C37,33.7,36.8,33.5,36.5,33.5z" />
    <g fill="#558B2F">
      <circle cx="24" cy="19" r="3" />
      <circle cx="36" cy="19" r="3" />
      <circle cx="12" cy="19" r="3" />
    </g>
    <path fill="#7CB342" d="M40,6H8C6.9,6,6,6.9,6,8v3h36V8C42,6.9,41.1,6,40,6z" />
    <rect x="21" y="11" fill="#7CB342" width="6" height="8" />
    <polygon fill="#7CB342" points="37,11 32,11 33,19 39,19" />
    <polygon fill="#7CB342" points="11,11 16,11 15,19 9,19" />
    <g fill="#FFA000">
      <circle cx="30" cy="19" r="3" />
      <path d="M45,19c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3L45,19z" />
      <circle cx="18" cy="19" r="3" />
      <path d="M3,19c0,1.7,1.3,3,3,3s3-1.3,3-3s-1.3-3-3-3L3,19z" />
    </g>
    <g fill="#FFC107">
      <polygon points="32,11 27,11 27,19 33,19" />
      <polygon points="42,11 37,11 39,19 45,19" />
      <polygon points="16,11 21,11 21,19 15,19" />
      <polygon points="6,11 11,11 9,19 3,19" />
    </g>
  </symbol>

  <symbol id="clipboard" width="24" height="24" viewBox="0 0 24 23.999999" version="1.1"
    xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg">
    <defs id="defs29" />
    <rect id="Rectangle_1716" data-name="Rectangle 1716" width="17.355932" height="20.740236" rx="2.6328449"
      fill="#434b62" x="3.3220339" y="3.2597642" style="stroke-width:1.09702" />
    <rect id="Rectangle_1717" data-name="Rectangle 1717" width="14.318288" height="17.094841" rx="0.98731679"
      fill="#ffffff" x="4.8408561" y="4.9952478" style="stroke-width:1.09702" />
    <rect id="Rectangle_1718" data-name="Rectangle 1718" width="9.7195854" height="1.1277351" rx="0.56386757"
      fill="#d2d4dc" x="7.1402073" y="8.2928848" style="stroke-width:1.09702" />
    <rect id="Rectangle_1719" data-name="Rectangle 1719" width="9.7195854" height="1.1277351" rx="0.56386757"
      fill="#d2d4dc" x="7.1402073" y="11.763852" style="stroke-width:1.09702" />
    <rect id="Rectangle_1720" data-name="Rectangle 1720" width="9.7195854" height="1.1277351" rx="0.56386757"
      fill="#d2d4dc" x="7.1402073" y="15.23482" style="stroke-width:1.09702" />
    <rect id="Rectangle_1721" data-name="Rectangle 1721" width="9.7195854" height="1.1277351" rx="0.56386757"
      fill="#d2d4dc" x="7.1402073" y="18.705786" style="stroke-width:1.09702" />
    <path id="Path_1273" data-name="Path 1273"
      d="m 14.168806,2.2186934 a 2.1699029,2.1699029 0 1 0 -4.338709,0 H 7.053543 v 3.7298634 h 9.892914 V 2.2186934 Z M 12,1.1765258 a 1.0553319,1.0553319 0 0 1 1.041071,1.0410706 1.042168,1.042168 0 1 1 -2.084336,0 A 1.002675,1.002675 0 0 1 12,1.1765258 Z"
      fill="#ffb432" style="stroke-width:1.09702" />
    <rect id="Rectangle_1722" data-name="Rectangle 1722" width="9.8929138" height="1.5621545" fill="#ffcf5b"
      x="7.0535431" y="4.3008347" style="stroke-width:1.09702" />
  </symbol>

  <symbol id="map" width="24" height="24" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
    xmlns:svg="http://www.w3.org/2000/svg">
    <defs id="defs54" />
    <g id="Icons" transform="matrix(0.9561753,0,0,0.9561753,-1.4999998e-8,0.14342628)">
      <path d="m 8.7,5.2 c 1.5,0.3 2.1,1.8 2.8,3.2 0.9,2 1.8,4.1 4.9,4.2 v -8 L 8.7,1.9 Z" style="fill:#e2daba"
        id="path18" />
      <path d="M 10.1,9 C 9.6,7.9 9.2,7.1 8.7,6.8 v 13.5 l 3.6,1.3 4.1,1.4 V 14.2 C 12.3,14.1 11,11.2 10.1,9.1 Z"
        style="fill:#e2daba" id="path20" />
      <path d="m 1.6,14.3 v 2.5 c 1,-0.8 1.5,-2.9 2,-5 C 4.2,9 4.9,5.9 7.1,5.2 V 1.9 L 1.6,3.7 Z" style="fill:#fffbe9"
        id="path22" />
      <path
        d="m 18.1,4.6 v 18.3 l 1.5,-0.5 v -3 c 0,-0.5 0.3,-0.9 0.7,-1 l 3.2,-1.1 V 2.5 Z m 4.4,1.5 c 0,0.2 -0.1,0.4 -0.4,0.5 l -2.2,0.8 c -0.2,0 -0.4,0 -0.4,-0.3 v -1 c 0,-0.2 0.1,-0.5 0.4,-0.5 l 2.2,-0.8 c 0.2,0 0.4,0 0.4,0.3 z"
        style="fill:#fffbe9" id="path24" />
      <path d="m 1.6,18.6 v 3.8 L 3.3,21.7 7,20.3 V 7 C 6,7.9 5.5,10 5,12.2 4.3,15.1 3.7,18 1.6,18.6 Z"
        style="fill:#fffbe9" id="path26" />
      <path
        d="M 17.1,10.9 C 15.7,10.6 14.8,7.9 13,7.2 12.5,7 11.2,6.7 10.1,7.6 c -1.2,1 -0.5,4.2 1,6.2 1.5,2.1 5,4.5 7.8,3.1 3,-1.6 3.2,-6.8 1.8,-7.7 -0.8,-0.5 -1.8,2.1 -3.6,1.7 z"
        style="fill:#64e89a" id="path28" />
      <path d="m 12.4,21.5 c 0,-0.2 0,-0.4 0,-0.6 0,-2.2 -1.6,-4.1 -3.7,-4.5 v 3.8 l 3.6,1.3 z" style="fill:#65dfe5"
        id="path30" />
      <path d="m 7.1,16.4 c -2.1,0.4 -3.8,2.2 -3.8,4.5 0,2.3 0,0.5 0,0.8 L 7,20.3 v -3.8 z" style="fill:#65dfe5"
        id="path32" />
      <path
        d="m 8.7,20.3 v -3.8 c -0.3,0 -0.6,0 -0.9,0 -0.3,0 -0.5,0 -0.8,0 v 3.8 l -3.7,1.4 c 0,0.5 0.3,1 0.5,1.5 l 3.9,-1.5 4,1.4 c 0.2,-0.5 0.4,-1 0.5,-1.5 L 8.6,20.3 Z"
        style="fill:#ffffff" id="path34" />
      <path
        d="m 12.4,20.9 c 0,0.2 0,0.4 0,0.6 l 4.1,1.4 V 14.1 C 12.4,14 11.1,11.1 10.2,9 9.7,7.9 9.3,7.1 8.8,6.8 v 9.7 c 2.1,0.4 3.7,2.2 3.7,4.5 z"
        style="fill:none" id="path36" />
      <path d="m 8.7,5.2 c 1.5,0.3 2.1,1.8 2.8,3.2 0.9,2 1.8,4.1 4.9,4.2 v -8 L 8.7,1.9 Z" style="fill:none"
        id="path38" />
      <path d="m 1.6,14.3 v 2.5 c 1,-0.8 1.5,-2.9 2,-5 C 4.2,9 4.9,5.9 7.1,5.2 V 1.9 L 1.6,3.7 Z" style="fill:none"
        id="path40" />
      <path
        d="m 18.1,22.9 1.5,-0.5 v -3 c 0,-0.5 0.3,-0.9 0.7,-1 l 3.2,-1.1 V 2.5 L 18.1,4.6 Z M 19.4,6.2 C 19.4,6 19.5,5.7 19.8,5.7 L 22,4.9 c 0.2,0 0.4,0 0.4,0.3 v 1 c 0,0.2 -0.1,0.4 -0.4,0.5 l -2.2,0.8 c -0.2,0 -0.4,0 -0.4,-0.3 z"
        style="fill:none" id="path42" />
      <path
        d="M 7.1,16.4 V 7 c -1,0.9 -1.5,3 -2,5.2 -0.7,2.9 -1.3,5.8 -3.4,6.4 v 3.8 l 1.7,-0.7 c 0,-0.3 0,-0.5 0,-0.8 0,-2.2 1.6,-4.1 3.8,-4.5 z"
        style="fill:none" id="path44" />
      <path
        d="M 19.8,7.4 22,6.6 c 0.2,0 0.4,-0.3 0.4,-0.5 v -1 C 22.4,4.9 22.2,4.8 22,4.8 l -2.2,0.8 c -0.2,0 -0.4,0.3 -0.4,0.5 v 1 c 0,0.2 0.2,0.3 0.4,0.3 z"
        style="fill:#544a43" id="path46" />
      <path
        d="M 23.6,0.8 17.3,3.3 8.2,0 C 8,0 7.7,0 7.5,0 L 0.8,2.3 C 0.3,2.5 0,2.9 0,3.4 V 23 c 0,0.8 0.8,1.3 1.5,1 l 2.4,-0.9 3.9,-1.5 4,1.4 5.1,1.8 c 0.2,0 0.5,0 0.7,0 l 6.7,-2.3 c 0.5,-0.2 0.8,-0.6 0.8,-1.1 V 1.8 C 25.1,1 24.3,0.5 23.6,0.8 Z M 7.1,9.8 V 20.2 L 3.4,21.6 1.7,22.3 V 18.5 C 3.8,17.9 4.5,15 5.1,12.1 5.6,10 6.1,7.8 7.1,6.9 Z m 0,-4.6 C 5,5.9 4.3,9 3.6,11.8 c -0.5,2.1 -1,4.3 -2,5 V 3.7 L 7,1.9 V 5.3 Z M 16.4,22.9 12.3,21.5 8.7,20.2 V 6.8 c 0.5,0.3 0.9,1.1 1.4,2.2 0.9,2.1 2.2,4.9 6.3,5.1 z m 0,-10.3 C 13.3,12.5 12.4,10.4 11.5,8.4 10.9,7 10.2,5.5 8.7,5.2 V 1.9 l 7.7,2.7 z m 7.1,4.7 -3.2,1.1 c -0.4,0.1 -0.7,0.6 -0.7,1 v 3 l -1.5,0.5 V 4.6 l 5.4,-2.1 z"
        style="fill:#544a43" id="path48" />
    </g>
  </symbol>

  <symbol id="booklet" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
    <path d="M36 44H8V8H28L36 16V44Z" fill="#42A5F5"/>
    <path d="M40 40H12V4H32L40 12V40Z" fill="#90CAF9"/>
    <path d="M38.5 13H31V5.5L38.5 13Z" fill="#E1F5FE"/>
    <path d="M24.5 28.3C24.5 23.6 28.1 23.9 28.1 21.1C28.1 20.4 27.9 19 26.1 19C24.1 19 24 20.6 24 21H21.3C21.3 20.3 21.6 16.8 26.1 16.8C30.7 16.8 30.8 20.4 30.8 21.1C30.8 24.6 27 25.1 27 28.4H24.5V28.3ZM24.3 31.8C24.3 31.6 24.3 30.3 25.8 30.3C27.2 30.3 27.3 31.6 27.3 31.8C27.3 32.2 27.1 33.2001 25.8 33.2001C24.5 33.2001 24.3 32.2 24.3 31.8Z" fill="#1976D2"/>
  </symbol>

  <symbol viewBox="0 0 24 24" id="ui" xmlns="http://www.w3.org/2000.svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.5 3.21967C11.7929 2.92678 12.2678 2.92678 12.5607 3.21967L22.0607 12.7197L21 13.7803L18.5303 11.3107V18.25C18.5303 18.6642 18.1945 19 17.7803 19H6.28033C5.86612 19 5.53033 18.6642 5.53033 18.25V11.3107L3.06066 13.7803L2 12.7197L11.5 3.21967ZM7.03033 9.81066V17.5H17.0303V9.81066L12.0303 4.81066L7.03033 9.81066Z"/>
  </symbol>
  <symbol viewBox="0 0 24 24" id="node" xmlns="http://www.w3.org/2000.svg">
    <path id="line_start_circle" d="M8 15.7115C9.02067 15.7115 9.89442 15.3481 10.6213 14.6213C11.3481 13.8944 11.7115 13.0207 11.7115 12C11.7115 10.9793 11.3481 10.1056 10.6213 9.37875C9.89442 8.6519 9.02067 8.28848 8 8.28848C6.97933 8.28848 6.10558 8.6519 5.37875 9.37875C4.6519 10.1056 4.28847 10.9793 4.28847 12C4.28847 13.0207 4.6519 13.8944 5.37875 14.6213C6.10558 15.3481 6.97933 15.7115 8 15.7115ZM8 17.2115C6.55237 17.2115 5.32187 16.7047 4.30852 15.6911C3.29519 14.6776 2.78852 13.4468 2.78852 11.9989C2.78852 10.5509 3.29519 9.32055 4.30852 8.30773C5.32187 7.29493 6.55237 6.78853 8 6.78853C9.32692 6.78853 10.474 7.21384 11.4413 8.06448C12.4086 8.91511 12.9801 9.97696 13.1557 11.25H21.4615V12.75H13.1557C12.9801 14.023 12.4086 15.0849 11.4413 15.9355C10.474 16.7862 9.32692 17.2115 8 17.2115Z"/>
  </symbol>
  <symbol  viewBox="0 0 24 24" id="section" xmlns="http://www.w3.org/2000.svg">
    <path id="cable" d="M5 20.75C4.7875 20.75 4.60939 20.6781 4.46565 20.5344C4.3219 20.3906 4.25003 20.2125 4.25003 20V18.9423H3.25003V15.1923C3.25003 14.9798 3.3219 14.8017 3.46565 14.6579C3.60939 14.5142 3.7875 14.4423 4 14.4423H5.25003V7C5.25003 5.9641 5.61605 5.08013 6.3481 4.3481C7.08014 3.61605 7.9641 3.25002 9 3.25002C10.0359 3.25002 10.9199 3.61605 11.6519 4.3481C12.384 5.08013 12.75 5.9641 12.75 7V17C12.75 17.6269 12.9683 18.1587 13.4048 18.5952C13.8413 19.0317 14.3731 19.25 15 19.25C15.6269 19.25 16.1587 19.0317 16.5952 18.5952C17.0318 18.1587 17.25 17.6269 17.25 17V9.55765H16C15.7875 9.55765 15.6094 9.48578 15.4656 9.34205C15.3219 9.1983 15.25 9.02017 15.25 8.80767V5.0577H16.25V4C16.25 3.7875 16.3219 3.60937 16.4656 3.46562C16.6094 3.32189 16.7875 3.25002 17 3.25002H19C19.2125 3.25002 19.3906 3.32189 19.5344 3.46562C19.6781 3.60937 19.75 3.7875 19.75 4V5.0577H20.75V8.80767C20.75 9.02017 20.6781 9.1983 20.5344 9.34205C20.3906 9.48578 20.2125 9.55765 20 9.55765H18.75V17C18.75 18.0359 18.384 18.9199 17.6519 19.6519C16.9199 20.3839 16.0359 20.75 15 20.75C13.9641 20.75 13.0801 20.3839 12.3481 19.6519C11.6161 18.9199 11.25 18.0359 11.25 17V7C11.25 6.37307 11.0318 5.84133 10.5952 5.4048C10.1587 4.96825 9.62694 4.74997 9 4.74997C8.37307 4.74997 7.84133 4.96825 7.4048 5.4048C6.96825 5.84133 6.74998 6.37307 6.74998 7V14.4423H8C8.2125 14.4423 8.39062 14.5142 8.53435 14.6579C8.6781 14.8017 8.74998 14.9798 8.74998 15.1923V18.9423H7.74998V20C7.74998 20.2125 7.6781 20.3906 7.53435 20.5344C7.39062 20.6781 7.2125 20.75 7 20.75H5Z"/>
  </symbol>

  <symbol id="sla" version="1.1" viewBox="0 0 512 512">
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M220.000000,24.000000 
	C290.153351,24.000004 359.806671,23.999418 429.460022,24.000755 
	C438.060883,24.000921 438.997314,24.913549 438.997986,33.351685 
	C439.001617,79.842796 439.116760,126.334587 438.845093,172.824112 
	C438.812805,178.352768 440.534027,180.247070 445.695404,181.031219 
	C459.787262,183.172195 471.742950,189.947052 481.447174,200.118912 
	C493.417999,212.666519 499.744720,227.621918 500.156647,245.371475 
	C500.668518,267.427124 492.330048,285.131561 476.055420,299.319641 
	C467.033020,307.185242 456.334412,312.272339 444.420654,313.720642 
	C439.490448,314.320007 438.939209,316.383209 438.946503,320.415985 
	C439.030518,366.906952 439.000397,413.398102 438.997772,459.889221 
	C438.997650,461.555328 439.102448,463.235931 438.924377,464.884491 
	C438.581696,468.057007 437.179016,470.247864 433.515808,469.997406 
	C432.686768,469.940735 431.850128,469.999268 431.016968,469.999268 
	C354.864868,469.999756 278.712769,470.001648 202.560654,469.996216 
	C195.877762,469.995728 193.643555,468.194946 194.032715,463.276611 
	C194.278351,460.172089 195.873123,458.359314 198.985550,458.078766 
	C200.639755,457.929657 202.315430,458.002380 203.981415,458.002319 
	C275.634369,457.999603 347.287354,458.000702 418.940308,457.998779 
	C425.990906,457.998596 425.998383,457.991089 425.998779,450.983337 
	C426.001190,407.491638 425.957489,363.999847 426.068115,320.508453 
	C426.078766,316.322418 425.646088,314.449524 420.498962,313.658783 
	C392.095001,309.295105 369.318054,284.604736 365.879395,256.152374 
	C362.908234,231.567841 371.200714,211.422668 389.360535,195.380539 
	C397.846405,187.884247 408.031616,182.804001 419.511444,180.977661 
	C421.462891,180.667221 423.370605,180.081787 425.720001,179.523178 
	C425.813934,177.715637 425.987366,175.928040 425.987976,174.140381 
	C426.003052,130.482056 425.933929,86.823494 426.096039,43.165779 
	C426.113312,38.517010 425.084229,36.882183 420.088409,36.892006 
	C341.437103,37.046665 262.785309,37.038879 184.133926,36.904552 
	C179.445709,36.896549 177.768417,37.974182 177.883118,42.944523 
	C178.209732,57.100937 178.017609,71.269836 177.987778,85.433723 
	C177.973969,91.987595 175.965958,93.972878 169.310013,93.988068 
	C154.812866,94.021156 140.312637,94.163506 125.820107,93.902916 
	C121.274498,93.821182 119.885368,95.122963 119.902504,99.758522 
	C120.066368,144.082764 120.001640,188.407867 119.994118,232.732727 
	C119.993835,234.397217 120.498558,236.447159 119.722961,237.635361 
	C118.575241,239.393631 116.474281,241.686142 114.808304,241.662903 
	C112.625160,241.632431 109.792877,240.054489 108.494034,238.242905 
	C107.195740,236.432098 107.072586,233.513290 107.068687,231.079178 
	C106.994308,184.588196 106.928398,138.096573 107.189377,91.606926 
	C107.208488,88.201851 108.869675,83.972046 111.228577,81.546898 
	C129.003265,63.272987 147.068695,45.278244 165.279419,27.437315 
	C167.251068,25.505707 170.708023,24.207834 173.507538,24.150351 
	C188.832916,23.835672 204.168152,24.000153 220.000000,24.000000 
M379.933350,260.451447 
	C382.309723,269.628387 386.591034,277.895966 393.216858,284.592773 
	C407.092926,298.617523 423.925507,304.570343 443.510956,300.809296 
	C454.479980,298.702911 464.292053,293.527527 471.913086,285.358643 
	C482.770111,273.721222 488.106934,259.856079 487.073578,243.607376 
	C486.036530,227.300446 478.929108,214.198486 466.391266,204.335785 
	C444.031433,186.746750 412.011505,189.543777 393.327301,210.141113 
	C380.345612,224.451981 375.496704,240.725082 379.933350,260.451447 
M164.999069,59.532703 
	C164.999069,55.676098 164.999069,51.819492 164.999069,48.719341 
	C154.165192,59.553173 143.434586,70.283752 132.752075,80.966232 
	C142.077774,80.966232 152.006775,81.085518 161.923584,80.792351 
	C162.982391,80.761047 164.764130,78.371254 164.850754,76.990288 
	C165.193893,71.519333 164.996262,66.014465 164.999069,59.532703 
z"/>
<path fill="#FF695A" opacity="1.000000" stroke="none" 
	d="
M95.795235,290.957947 
	C99.678780,290.135651 98.974167,287.394440 98.996964,285.004974 
	C99.014191,283.199036 99.000374,281.392822 99.000374,278.999878 
	C96.108856,278.999878 93.498871,279.020294 90.889305,278.995544 
	C85.708366,278.946442 82.020699,276.592499 80.965408,271.386200 
	C80.064941,266.943695 79.678452,262.156219 80.321190,257.702667 
	C81.125313,252.130859 85.839523,249.029572 91.733391,249.013245 
	C106.230698,248.973053 120.728195,248.994247 135.225616,249.002518 
	C142.324738,249.006561 146.242599,251.607910 147.602692,258.300415 
	C148.346710,261.961456 148.489777,266.085449 147.590134,269.671051 
	C145.508911,277.966064 141.072632,279.715027 135.374817,279.036499 
	C133.440750,278.806183 131.456177,279.000000 129.673599,279.000000 
	C129.345367,279.675598 129.096802,279.954315 129.086868,280.241302 
	C128.754669,289.850616 128.821457,289.610352 138.238846,292.095856 
	C143.852295,293.577454 149.331268,295.716400 154.682724,298.000275 
	C159.830551,300.197296 164.736282,302.961609 169.827911,305.516541 
	C172.097046,303.816193 171.667252,302.444153 169.310638,300.755127 
	C163.925400,296.895325 161.809631,287.936432 165.329529,282.420074 
	C168.221252,277.888184 175.024460,272.824829 182.238983,275.980804 
	C186.990921,278.059540 191.971695,279.727661 196.464493,282.262848 
	C205.903458,287.589050 207.452667,301.134216 196.810928,307.309235 
	C193.266479,309.365967 188.158569,308.728271 183.080978,309.414886 
	C182.771683,310.121643 181.942352,312.016663 180.880829,314.442200 
	C206.427979,337.641785 217.141922,367.219055 213.750381,401.321350 
	C211.179474,427.171967 199.221115,449.137695 179.341400,465.983765 
	C138.286301,500.773987 76.101173,498.496765 37.934837,455.466949 
	C7.420683,421.064423 0.668514,357.009277 47.050552,314.232880 
	C46.180710,312.440704 45.275284,310.575226 44.247627,308.457916 
	C36.973682,309.840393 30.211830,309.588165 25.863594,302.330505 
	C21.732325,295.434967 24.377714,285.684967 31.551922,282.172974 
	C36.067940,279.962250 40.640354,277.800751 45.356682,276.081299 
	C51.759701,273.746857 58.960144,276.429413 62.515472,282.022858 
	C65.600555,286.876465 64.133942,295.502563 59.528019,300.009888 
	C57.965801,301.538666 54.676079,302.777252 58.344646,305.690460 
	C69.691612,298.414703 81.869347,293.025452 95.795235,290.957947 
M121.145454,476.991821 
	C123.897133,476.598663 126.686829,476.378845 129.394485,475.784973 
	C151.423431,470.953247 169.619064,460.064606 183.528320,442.048889 
	C198.142746,423.119720 203.591522,401.443939 200.687027,378.308594 
	C197.686844,354.411377 185.952682,334.570923 166.422302,319.992188 
	C144.658249,303.746155 120.449364,298.399933 93.805412,304.588623 
	C72.392807,309.562164 55.767464,321.735016 42.746265,338.919708 
	C33.962433,350.512177 28.671328,364.011566 27.214094,378.387329 
	C25.715174,393.174194 26.876707,407.878571 32.839664,422.024780 
	C39.154747,437.006378 48.673820,449.274475 61.452034,459.047028 
	C78.765686,472.288239 98.495789,477.970947 121.145454,476.991821 
M131.252350,265.999786 
	C133.830353,266.129150 136.113068,265.994110 134.481155,262.234436 
	C120.784554,262.234436 107.068962,262.234436 93.412193,262.234436 
	C92.202759,265.537323 93.717209,266.060669 96.425064,266.038422 
	C107.717453,265.945587 119.011047,265.999756 131.252350,265.999786 
M115.999580,282.630981 
	C115.616524,279.235687 115.616524,279.235687 112.328819,279.552277 
	C111.421707,288.874817 111.434654,288.908875 115.999809,288.379150 
	C115.999809,286.791382 115.999809,285.165558 115.999580,282.630981 
M184.372849,291.063080 
	C182.092789,290.032959 179.812729,289.002808 177.307663,287.871033 
	C177.880585,291.772156 186.076340,295.965637 191.814224,295.104126 
	C189.105896,293.671661 187.053986,292.586365 184.372849,291.063080 
M49.710827,288.084747 
	C45.393536,290.314697 41.076241,292.544678 36.758945,294.774658 
	C37.020725,295.300323 37.282505,295.826019 37.544285,296.351685 
	C41.965229,294.380066 46.399574,292.436523 50.766190,290.351135 
	C50.977139,290.250397 50.591831,288.901123 49.710827,288.084747 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M158.000458,224.040894 
	C158.000641,209.000916 158.000641,209.000656 172.721100,209.001038 
	C182.385757,209.001297 192.051178,209.073242 201.714737,208.970718 
	C205.988571,208.925354 209.155487,210.326706 210.725342,214.856384 
	C212.497192,213.740616 214.043930,212.524902 215.782181,211.725739 
	C218.778763,210.348022 222.301926,210.298080 223.593124,213.482407 
	C224.582169,215.921524 223.539536,219.186386 223.380020,222.082840 
	C223.373154,222.207489 223.175385,222.342957 223.040787,222.436188 
	C212.543030,229.707764 209.345276,239.677002 210.806274,252.157516 
	C211.652496,259.386139 208.293228,261.992096 201.118134,261.997498 
	C189.620514,262.006134 178.122803,262.028229 166.625336,261.987671 
	C159.732452,261.963379 158.015259,260.243805 158.004639,253.526932 
	C157.989349,243.862305 158.000549,234.197647 158.000458,224.040894 
M175.020477,228.669250 
	C176.779037,222.531448 181.812637,220.880997 186.564743,225.257324 
	C188.956696,227.460129 190.578964,230.498718 192.549286,233.159363 
	C193.408264,233.029739 194.267227,232.900101 195.126205,232.770477 
	C195.882599,231.478683 196.655991,230.196472 197.392014,228.893204 
	C199.100250,225.868500 197.892197,222.146057 195.002808,222.081451 
	C188.030121,221.925552 181.047104,221.909485 174.080231,222.164627 
	C173.032272,222.203003 171.209030,223.971771 171.170975,224.993225 
	C170.911453,231.959717 170.933868,238.943436 171.141815,245.913330 
	C171.172440,246.939987 172.642426,248.770462 173.486832,248.794220 
	C181.391769,249.016678 189.305496,248.926132 197.216690,248.926132 
	C191.314209,249.237717 187.774963,245.528198 184.220398,241.771683 
	C181.937958,239.359528 179.358246,237.203888 177.273666,234.639145 
	C176.131042,233.233307 175.739700,231.216858 175.020477,228.669250 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M158.000519,168.960251 
	C158.001175,158.484543 157.971909,148.501740 158.014069,138.519226 
	C158.038132,132.824982 159.787689,131.036804 165.406845,131.015778 
	C177.385895,130.970947 189.365494,131.046158 201.344315,130.976151 
	C205.708618,130.950653 209.936783,130.885468 210.346664,137.391708 
	C211.892883,136.229156 212.727310,135.737289 213.394836,135.076782 
	C216.552658,131.952103 220.002640,131.410858 223.556580,134.180481 
	C226.013687,136.095352 225.663422,141.424118 222.829681,144.572754 
	C220.051178,147.660019 216.705627,150.271500 214.165741,153.526291 
	C212.587036,155.549377 211.431107,158.317230 211.169022,160.862381 
	C210.694290,165.472382 211.130173,170.168549 211.001724,174.823669 
	C210.830185,181.040283 208.364716,183.813004 202.247040,183.913940 
	C190.104843,184.114288 177.955215,184.098480 165.812332,183.920837 
	C160.026352,183.836197 158.120499,181.624512 158.010254,175.941925 
	C157.968292,173.779800 158.001541,171.616196 158.000519,168.960251 
M196.878036,169.925247 
	C193.062057,170.598404 190.198593,169.185455 187.686813,166.276306 
	C185.299698,163.511520 182.362732,161.224564 179.940216,158.486298 
	C178.084412,156.388611 175.730652,154.072418 175.303131,151.562973 
	C174.907516,149.240784 176.775742,146.532913 177.667175,143.936157 
	C175.909210,144.057648 173.672638,144.212189 171.029755,144.394821 
	C171.029755,152.570648 170.917374,160.213226 171.158463,167.844635 
	C171.192200,168.912491 172.953323,170.815094 173.927383,170.823196 
	C181.700943,170.887924 189.477554,170.588959 196.878036,169.925247 
M195.637375,152.827789 
	C198.546661,150.471451 198.458237,147.594482 197.274231,144.246460 
	C192.576889,144.246460 188.068939,144.246460 185.585876,144.246460 
	C186.883438,145.984314 188.794235,148.878494 191.080185,151.437561 
	C191.974854,152.439117 193.711365,152.688675 195.637375,152.827789 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M283.000000,322.000000 
	C315.828491,322.000122 348.156982,321.996216 380.485474,322.003937 
	C386.525238,322.005371 388.941833,323.706268 388.976044,327.900818 
	C389.009460,331.998108 385.618073,334.967224 380.445801,334.970795 
	C327.120483,335.007568 273.795135,335.022552 220.469864,334.955078 
	C213.518799,334.946259 209.599716,330.529175 211.661118,325.685608 
	C212.996124,322.548828 215.396729,321.948059 218.509613,321.959656 
	C239.839508,322.039246 261.169830,322.000580 283.000000,322.000000 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M240.087585,355.000000 
	C286.404541,355.000000 332.234070,354.999390 378.063629,355.002533 
	C379.729736,355.002655 381.413177,354.893341 383.058380,355.088867 
	C386.698151,355.521454 388.839661,357.666260 388.905670,361.334167 
	C388.976135,365.253265 386.775482,367.467072 382.897552,367.939758 
	C381.910706,368.060059 380.900055,367.997467 379.900330,367.997528 
	C332.237610,367.999603 284.574860,367.998383 236.912125,368.000946 
	C232.729904,368.001190 228.632156,367.762482 228.046829,362.314728 
	C227.548904,357.680511 229.890900,355.167419 234.600922,355.014374 
	C236.265732,354.960297 237.933670,355.002014 240.087585,355.000000 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M300.000000,166.998459 
	C326.471771,166.998489 352.443542,166.997894 378.415314,167.000046 
	C379.913544,167.000168 381.425812,166.895370 382.907379,167.058655 
	C387.096130,167.520294 389.093414,170.082504 388.930725,174.147568 
	C388.769501,178.176544 386.370483,180.008926 382.395844,180.000641 
	C371.907318,179.978806 361.418701,179.998489 350.930115,179.998627 
	C314.469757,179.999115 278.009125,180.052551 241.549683,179.868652 
	C239.265121,179.857117 236.140793,178.557587 234.961914,176.809036 
	C233.896072,175.228165 234.070969,171.423019 235.309143,170.026169 
	C236.873627,168.261200 240.060181,167.155426 242.563492,167.125122 
	C261.540070,166.895554 280.520660,166.998932 300.000000,166.998459 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M265.000000,80.998444 
	C303.446747,80.998611 341.393585,80.975082 379.340149,81.054649 
	C381.755768,81.059723 384.998627,81.070839 386.370941,82.502899 
	C388.022858,84.226677 388.986816,87.653008 388.523346,90.001877 
	C388.202576,91.627762 385.060394,93.585197 383.008026,93.805992 
	C377.907166,94.354782 372.708466,93.998222 367.549072,93.998329 
	C325.607941,93.999199 283.666534,94.052986 241.726288,93.857216 
	C239.316147,93.845978 236.254974,92.341759 234.740677,90.506195 
	C233.716507,89.264755 234.049667,85.417145 235.256790,84.177994 
	C236.965775,82.423653 240.001633,81.278572 242.538177,81.143227 
	C249.840561,80.753532 257.176971,81.001175 265.000000,80.998444 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M232.004425,288.000916 
	C273.127411,288.001038 313.751465,287.983765 354.375397,288.047577 
	C356.638611,288.051147 359.473175,288.018188 361.015930,289.268311 
	C362.868835,290.769745 364.631042,293.641968 364.603333,295.898163 
	C364.565674,298.960693 362.279602,301.128357 358.505371,301.040894 
	C351.350128,300.875061 344.188232,300.999512 337.029083,300.999634 
	C298.902435,301.000397 260.775818,301.000061 222.649170,300.999725 
	C221.317245,300.999725 219.981705,300.931580 218.654037,301.005768 
	C214.221344,301.253418 211.705841,299.076172 211.220459,294.799561 
	C210.849960,291.535278 214.397812,288.259857 218.521332,288.071350 
	C222.841400,287.873810 227.176758,288.010376 232.004425,288.000916 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M382.443298,414.971252 
	C346.177216,414.990417 310.358185,414.955933 274.539551,415.057587 
	C270.934143,415.067810 268.048676,414.030182 267.075531,410.652771 
	C266.532135,408.766937 266.924286,405.856781 268.117859,404.434631 
	C269.344299,402.973358 272.057159,402.108215 274.123749,402.100403 
	C309.775574,401.965454 345.428101,402.018372 381.080414,401.982697 
	C385.010773,401.978790 388.170624,403.157684 388.809296,407.359009 
	C389.464844,411.671631 387.294037,414.315094 382.443298,414.971252 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M343.511597,247.149445 
	C346.999268,254.691345 344.689941,258.887695 336.892487,258.922913 
	C305.265869,259.065735 273.638184,259.015869 242.011078,258.950562 
	C237.292435,258.940826 233.977066,255.776443 234.022675,251.876312 
	C234.070221,247.809982 236.473724,246.008408 242.025360,246.006256 
	C273.985565,245.993881 305.945801,245.986191 337.905914,246.038300 
	C339.672211,246.041168 341.437622,246.592850 343.511597,247.149445 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M279.000000,134.000946 
	C291.494354,134.003326 303.489136,133.946609 315.482849,134.035660 
	C320.666870,134.074142 323.250092,136.647369 322.952393,141.230179 
	C322.707153,145.004364 320.524323,146.966843 316.787048,146.971390 
	C291.299133,147.002396 265.811066,146.969147 240.323151,147.009079 
	C236.006866,147.015839 234.440628,144.340622 234.102615,140.724823 
	C233.732101,136.761505 236.509537,134.073761 241.017838,134.040054 
	C253.511292,133.946609 266.005859,134.003494 279.000000,134.000946 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M262.000000,212.999542 
	C279.966888,212.999786 297.433990,213.043488 314.900543,212.967575 
	C318.917053,212.950119 322.366547,213.586365 322.920105,218.326141 
	C323.509735,223.374969 319.760101,224.762527 315.933899,225.783051 
	C314.680481,226.117355 313.290161,225.986099 311.962402,225.986694 
	C289.671326,225.996689 267.380066,226.031296 245.089355,225.940384 
	C242.656158,225.930450 239.677841,225.901352 237.942108,224.580521 
	C236.047958,223.139145 234.070724,219.970459 234.419281,217.949631 
	C234.749054,216.037811 237.945587,213.412994 240.059357,213.236679 
	C247.163391,212.644104 254.346909,213.004089 262.000000,212.999542 
z"/>

<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M418.268188,262.767242 
	C415.049103,259.867279 411.985931,257.321869 409.145111,254.548660 
	C405.375061,250.868408 405.037811,246.701431 408.013062,243.571014 
	C410.597534,240.851776 414.934113,241.330399 418.429413,245.002823 
	C420.712952,247.402161 422.674561,250.107880 425.292755,253.301315 
	C431.783142,246.289108 437.262360,240.386734 442.719513,234.464111 
	C444.619263,232.402344 446.343506,230.163803 448.363434,228.231323 
	C451.360046,225.364410 454.595642,225.349945 457.630615,228.228455 
	C460.766235,231.202484 460.399017,234.675369 457.836151,237.521759 
	C449.180511,247.134933 440.379974,256.623322 431.429474,265.962616 
	C427.696320,269.857941 424.447174,268.937683 418.268188,262.767242 
z"/>
<path fill="#FF695A" opacity="1.000000" stroke="none" 
	d="
M187.747971,415.585754 
	C181.076370,433.059509 170.129181,446.485321 154.532211,456.128387 
	C143.645004,462.859497 131.935013,466.342316 119.072456,467.135071 
	C97.855331,468.442719 79.433281,462.435608 63.189865,448.780487 
	C49.797997,437.522522 41.702480,423.277435 37.821194,406.446686 
	C34.022423,389.973724 35.675930,373.902466 42.276928,358.441284 
	C49.526073,341.461945 61.801235,328.779144 77.904442,320.140991 
	C87.230148,315.138489 97.386162,312.303864 108.246590,311.885986 
	C122.254402,311.347015 135.825836,312.977966 148.366425,319.233307 
	C161.351425,325.710327 171.924103,335.293915 179.830093,347.548798 
	C189.275909,362.190552 193.074051,378.427795 191.851044,395.666718 
	C191.384262,402.246368 189.290466,408.710571 187.747971,415.585754 
M53.997696,414.435791 
	C58.431114,424.637238 64.782005,433.268768 73.620453,440.231628 
	C88.539368,451.984619 105.425156,456.804932 123.946190,453.768982 
	C140.124313,451.117035 153.781693,443.306519 164.382645,430.266602 
	C173.023376,419.637848 177.995224,407.515381 178.810471,394.200653 
	C180.085770,373.372375 172.707489,355.710419 157.044266,341.431519 
	C141.022385,326.825592 122.346413,322.027557 101.574867,326.107758 
	C75.375488,331.254150 58.703575,347.646271 51.199230,372.939148 
	C47.150986,386.583527 47.857224,400.421600 53.997696,414.435791 
z"/>

<path fill="#FF695A" opacity="1.000000" stroke="none" 
	d="
M141.685425,383.000092 
	C144.746826,384.329620 148.310898,385.062714 149.629333,387.188538 
	C150.581360,388.723541 148.835632,392.250031 147.697235,394.599579 
	C147.268402,395.484650 145.173126,395.892303 143.817780,395.938568 
	C139.169983,396.097351 134.513443,395.999512 129.934311,395.999512 
	C124.040535,405.298004 117.149582,407.955536 107.700752,405.053772 
	C100.928970,402.974152 98.275421,397.531586 97.200409,391.565033 
	C96.132004,385.635162 98.403496,379.912048 103.427299,376.469055 
	C106.429581,374.411530 107.093300,372.352539 107.039276,369.183990 
	C106.911728,361.702545 106.852356,354.213623 107.042831,346.734833 
	C107.217430,339.879761 112.270424,336.013977 116.961761,339.151855 
	C118.509666,340.187195 119.795464,342.750122 119.865532,344.663483 
	C120.175751,353.133606 119.855530,361.626038 120.120903,370.099213 
	C120.174484,371.809967 121.627739,373.580994 122.728432,375.114044 
	C123.345337,375.973297 125.080284,376.192505 125.428833,377.056305 
	C128.576218,384.856354 135.264938,382.908234 141.685425,383.000092 
M116.354828,386.909058 
	C114.393196,387.289764 112.404175,387.586182 110.518044,388.199188 
	C110.354004,388.252502 110.468132,390.927734 111.156540,391.440430 
	C112.303673,392.294647 114.020348,392.384125 115.497208,392.795624 
	C115.961113,391.014526 116.425026,389.233429 116.354828,386.909058 
z"/>
  </symbol>

</svg>
